/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable @typescript-eslint/no-redeclare */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react-hooks/rules-of-hooks */
// import styles from "../transaction/transaction.module.css"
import axios from "axios";
import { baseUrlDefiner } from "../../utils/config";
import React, { useState, useEffect, useRef, memo } from "react";
import { tokenDecode } from "../../utils/helper";
import { config } from "../../utils/config";
import { toast } from "react-toastify";
import jwtDecode from "jwt-decode";
import { v4 as uuidv4 } from "uuid";
import { useLocation, useParams } from "react-router-dom";
import Variants from "../../components/Variants/Variants";
import CloseIcon from '@mui/icons-material/Close';
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Papa from 'papaparse';
import ImageAdd from '../../components/ImageAdd/ImageAdd';
import ThemeMaker from "../../components/thememaker";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import DeleteIcon from '@mui/icons-material/Delete';
import * as XLSX from 'xlsx';
import * as excelJs from 'exceljs';
import CircularProgress from '@mui/material/CircularProgress';
import styles from "./style.module.css";
import EditNoteRoundedIcon from '@mui/icons-material/EditNoteRounded';
import { Multiselect } from "multiselect-react-dropdown"
import { IndianStates } from "../../utils/rawdata";
import dayjs from "dayjs";
import { FiRefreshCcw, FiInfo, FiTag, FiDollarSign, FiLayers, FiGrid, FiBox, FiPackage, FiCheckCircle } from "react-icons/fi";
import { FaRupeeSign } from "react-icons/fa";
// import {fetchSellerList} from "../sellerlist/index"
import { Modal as AntModal, Input, Form, Upload, message, Spin, DatePicker, Select } from "antd";
import { SizeData, ColourData, FabricData, daysData, UOMData, MaterialData, ShoeSizedata, SizeDataBoyGirl } from '../../utils/rawdata';
import { daysToWeeks, setDate } from "date-fns";
import { useHistory } from "react-router-dom";
import { Button, Dropdown, Space } from 'antd';

const { apiEndpoint, awsKeyId, awsSecretKey, awsRegion, awsBucket, baseNodeapiUrl } = config;
const aws = require("aws-sdk");
const smstyle = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "80%", bgcolor: 'background.paper', boxShadow: 24, borderRadius: "10px", p: 1, maxHeight: 600, overflow: "scroll", color: "black",
};
const sPmstyle = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "80%", bgcolor: 'background.paper', boxShadow: 24, borderRadius: "10px", p: 1, overflow: "scroll", color: "black",
};
const Sstyle = {
  position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', borderRadius: "10px", bgcolor: 'background.paper', border: '1px solid #000', boxShadow: 24, p: 2,
};
const anchorStyle = { fontSize: "12px", textDecoration: "underline", cursor: "pointer" }

const { RangePicker } = DatePicker;
// const { data } = fetchSellerList;

const normalizeCountryCode = (value) => String(value ?? "").replace(/[^a-z]/gi, "").toUpperCase().slice(0, 3);

const createProduct = () => {

  const history = useHistory()
  const defaultTreeData = [
    {
      // id: "group1",
      id1: `cg-${Date.now()}`,
      name: "crust(1 option)",
      ondc_product_id: "b94fe2b3-e282-4102-804c-7653b2a59fca",
      seller_id: "60",
      config_min: "1",
      config_max: "1",
      config_seq: "1",
      mandatory: "true",
      type: "group",
      elements: [
        {
          id: `element-${Date.now()}`,
          default_selection: true,
          ondc_product_id: "b94fe2b3-e282-4102-804c-7653b2a59fca",
          customization: "c1",
          name: "new hand tossed",
          parent_id: "cg1",
          child: ["cg2"],
          price: "130",
          quantity: "20",
          check_item: "true",
          lower_price: null,
          upper_price: null,
          check_default_parent: "true",
          tax: "2.00",
          type: "element",
          elements: [],
        },
      ],
    },
  ]
  // const fullUrl = window.location.host;

  const [Oweekdays, setOweekdays] = useState([
    { day: "Monday" }, { day: "Tuesday" }, { day: "Wednesday" }, { day: "Thursday" }, { day: "Friday" }, { day: "Saturday" }, { day: "Sunday" },
  ])








  const decode = tokenDecode();
  const userObj = Array.isArray(decode?.data?.user) ? decode?.data?.user[0] : (decode?.data?.user || {});
  const roleObj = Array.isArray(decode?.data?.role) ? decode?.data?.role[0] : (decode?.data?.role || {});
  let current_sellerid = userObj?.seller_id ?? userObj?.parent_id ?? roleObj?.seller_id ?? decode?.data?.seller_data?.[0]?.seller_id;
  const [brandlist, setbrandlist] = useState([]);
  const [isBrandLoading, setIsBrandLoading] = useState(false);
  const [isCreateBrandModalOpen, setIsCreateBrandModalOpen] = useState(false);
  const [newBrandName, setNewBrandName] = useState("");
  const [newBrandImage, setNewBrandImage] = useState("");
  const [isBrandCreating, setIsBrandCreating] = useState(false);
  const [brandImageUploading, setBrandImageUploading] = useState(false);
  const [sampleCSVdata, setSampleCSV] = useState({ category: "", product_type: "", sub_category: "", product_type_array: [], gender_specification: "" })
  const [mopen, setmopen] = React.useState(false);
  const [StateBasedPriceingopen, setStateBasedPriceingopen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [iopen, setiopen] = React.useState(false);
  const [featureopen, setfeatureopen] = React.useState(false);
  const [categoryOption, setCategoryOption] = React.useState("");
  const [hideWarehouses, setHideWarehouses] = useState(false);
  const handleOpen = () => setmopen(true);
  const handleImageOpen = () => setiopen(true);
  const handleFeaturesOpen = () => setfeatureopen(true);
  const handleClose = () => setmopen(false);
  const [selectedWarehouses, setSelectedWarehouses] = useState({});
  const handleStateBasedPricingModalClose = () => setStateBasedPriceingopen(false);
  const handleimageClose = () => setiopen(false);
  const handleFeaturesClose = () => setfeatureopen(false);
  const [showModal, setShowModal] = useState(false);
  const [treeData, setTreeData] = useState([]);
  const [isEdited, setIsEdited] = useState(false);
  const [isFandB, setisFandB] = useState(false)
  const [selectedDomain, setselectedDomain] = useState();
  const [deliverycheck, setDelivery] = useState()
  console.log("deliverycheck==-=->", deliverycheck?.sellers_charges)
  const [sameQty, setSameQty] = useState(false);
  const [warehouseQty, setWarehouseQty] = useState({});
  const [tempSelectedWarehouses, setTempSelectedWarehouses] = useState([]);
  const [tempWarehouseQty, setTempWarehouseQty] = useState("");

  const [attributesState, setattributeState] = useState({
    data: [],
    attr_is_loading: false,
    submitting: false,
    parent_category_id: "",
    // product_type_id: "",
    editing_attr_id: "",
    editing_attr_value: "",
    adding_new_attr: false,
    new_attr_value: "",
    new_attr_options: "",
    new_attr_type: "",
    stateName: "",
    price: "",
    status: false,
    start_date: "",
    end_date: "",
    maximum_price: "",
    end_date: "",
    isUpdatingItem: false,
    makeDisable: false
  })


  const [selectedODays, setSelectedODays] = useState();


  const returnWindowLength = new Array(1, 2, 3, 4, 5, 6, 7);
  const timeToShipLength = new Array(1, 2, 3, 4, 5, 6, 7);
  const [taxData, setTaxData] = useState([]);
  const [readOnly, setreadOnly] = useState(false);

  const rawData = {
    name: "",
    short_description: "",
    long_description: "",
    category_id: "",
    brand: "",
    brand_id: "",
    tags: "",
    product_type_id: "",
    product_type_name: "",
    has_variations: false,
    country_of_origin: "IND",
    customer_care_number: "",
    // parent_id: "",
    // cms: "",
    status: true,
    pc_manufacturer_or_packer_name: "",
    pc_manufacturer_or_packer_address: "",
    pf_brand_owner_FSSAI_license_no: "",
    pc_common_or_generic_name_of_commodity: "",
    pc_month_year_of_manufacture_packing_import: "",
    pc_imported_product_country_of_origin: "India",
    tax: "",
    tax_included: true,
    sku: "",
    gtin: "",
    hsn: "",
    uom: "unit",
    uom_value: "",
    weight: "",
    weights: "",
    max_quantity: "",
    min_quantity: "",
    set: "",
    case: "",
    selling_unit: "",
    package_type: "",
    dimensions: "",
    pack_config_set: "",
    pack_config_case: "",
    pack_config_selling_unit: "",
    packing_height: "",
    packing_length: "",
    packing_breadth: "",
    packing_weight: "",
    packing_price: "",
    currency: "INR",
    base_price: "",
    selling_price: "",
    minimum_price: "",
    maximum_price: "",
    returnable: "",
    cancelable: "",
    replaceable: "",
    seller_pickup_return: "",
    return_window: "",
    time_to_ship: "",
    time_to_deliver: "",
    cod_allowed: "",
    quantity: 1,
    image: [],
    attributes: [
      {
        attribute_name: "", attribute_value: ""
      }
    ],
    buyerappdata: []
  };

  const rawDataError = {
    name: false,
    category_id: false,
    // short_description: false,
    description: false,
    quantity: false,
    maximum_price: false,
    selling_price: false,
    image: false,
    returnable: false,
    cancelable: false,
    return_window: false,
    seller_pickup_return: false,
    time_to_ship: false,
    product_type: false,
    gtin: false,
    // uom: false,
    replaceable: false,
    weight: false,
    set: false,
    case: false,
    selling_unit: false,
    min_quantity: false,
    max_quantity: false,
    time_to_deliver: false,
    cod_allowed: false,
    brand: false
  };

  const [file, setFile] = useState(null);
  const [shipmentModalOpen, setshipmentModalOpen] = useState(false);
  const [downloadCSVModalOpen, setdownloadCSVModalOpen] = useState(false);
  const [productTypes, setproductTypes] = useState([]);
  const [product, setProduct] = useState(rawData);
  // console.log("productstate----------->", product)
  const [productErr, setProductErr] = useState(rawDataError);
  // const [allDynamicField, setallDynamicFiled] = useState({
  //   gender: "",
  //   size_chart: "",
  //   fabric: ""
  // })
  const [categoryList, setCategoryList] = useState([]);
  const [productTypeName, setproductTypeName] = useState("");
  let params = useParams();
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const productIdFromQuery = urlParams?.get('productId') || urlParams?.get('id');
  const id = params?.id || productIdFromQuery;
  const fullUrl = window.location.host;

  useEffect(() => {
    if (showModal) {
      setTreeData(JSON.parse(JSON.stringify(defaultTreeData)));
      setIsEdited(false);
    }
  }, [showModal]);

  const handleChange = (e, path, key) => {
    const value = e.target.value;
    setIsEdited(true);
    setTreeData((prevTreeData) => {
      const newTreeData = JSON.parse(JSON.stringify(prevTreeData));
      let currentNode = newTreeData;
      path.forEach((index, idx) => {
        if (idx === path.length - 1) {
          currentNode[index][key] = value;
        } else {
          currentNode = currentNode[index].elements;
        }
      });
      return newTreeData;
    });
  };

  const handleModelClose = () => {
    setShowModal(false);
    if (!isEdited) {
      setTreeData([]);
    }
  };
  const handleToggleSelection = (path) => {
    const updatedTreeData = [...treeData];

    let currentNode = updatedTreeData;
    path.forEach((index, idx) => {
      if (idx === path.length - 1) {
        currentNode[index].default_selection = !currentNode[index].default_selection;
      } else {
        currentNode = currentNode[index].elements;
      }
    });

    setTreeData(updatedTreeData);
  };

  const handleAddElement = (path) => {
    const updatedTreeData = [...treeData];

    let currentNode = updatedTreeData;
    path.forEach((index) => {
      currentNode = currentNode[index].elements;
    });

    currentNode.push({
      id: `element-${Date.now()}`,
      default_selection: false,
      ondc_product_id: "",
      customization: "",
      name: "",
      parent_id: "",
      child: [],
      price: "",
      quantity: "",
      check_item: "true",
      lower_price: null,
      upper_price: null,
      check_default_parent: "true",
      tax: "",
      type: "element",
      elements: [],
    });

    setTreeData(updatedTreeData);
  };

  const handleAddGroup = (path) => {
    const updatedTreeData = [...treeData];

    let currentNode = updatedTreeData;
    path.forEach((index) => {
      currentNode = currentNode[index].elements;
    });

    currentNode.push({
      // id: `group-${Date.now()}`,
      id1: `cg-${Date.now()}`,
      name: "",
      ondc_product_id: "",
      seller_id: "",
      config_min: "1",
      config_max: "1",
      config_seq: "",
      mandatory: "true",
      type: "group",
      elements: [],
    });

    setTreeData(updatedTreeData);
  };

  const renderTree = (nodes, path = []) => {
    return nodes.map((node, index) => {
      const currentPath = [...path, index];






      return (
        <div
          key={currentPath.join("-")}
          className="mb-3"
          style={{
            marginLeft: 20,
          }}
        >
          {/* Group or Item Rendering */}
          {node.type === "group" ? (
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title font-weight-bolder form-control-plaintext text-primary">Custom Group</h5>

                <div className="row g-3">
                  <div className="col-md-6">
                    <label className="form-label genericlabel">ID1</label>
                    <input
                      type="text"
                      className="form-control"
                      value={node.id1}
                      onChange={(e) => handleChange(e, currentPath, "id1")}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label genericlabel">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={node.name}
                      onChange={(e) => handleChange(e, currentPath, "name")}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label genericlabel">Config Min</label>
                    <input
                      type="number"
                      className="form-control"
                      value={node.config_min}
                      onChange={(e) => handleChange(e, currentPath, "config_min")}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label genericlabel">Config Max</label>
                    <input
                      type="number"
                      className="form-control"
                      value={node.config_max}
                      onChange={(e) => handleChange(e, currentPath, "config_max")}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
                  <button
                    className="btn btn-outline-primary w-25"
                    onClick={() => handleAddElement(currentPath)}
                  >
                    Add Item
                  </button>
                </div>
              </div>
            </div>
          ) : (
            <div className="card shadow-sm">
              <div className="card-body">
                <h5 className="card-title font-weight-bolder form-control-plaintext text-success">Custom Item</h5>

                <div className="form-check mb-3">
                  <input
                    type="checkbox"
                    className="form-check-input"
                    id={`default-selection-${currentPath}`}
                    onChange={() => handleToggleSelection(currentPath)}
                  />
                  <label
                    className="form-check-label genericlabel"
                    htmlFor={`default-selection-${currentPath}`}
                  >
                    Default Selection
                  </label>
                </div>

                <div className="row g-3">
                  <div className="col-md-4">
                    <label className="form-label genericlabel">Name</label>
                    <input
                      type="text"
                      className="form-control"
                      value={node.name}
                      onChange={(e) => handleChange(e, currentPath, "name")}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label genericlabel">Price</label>
                    <input
                      type="number"
                      className="form-control"
                      value={node.price}
                      onChange={(e) => handleChange(e, currentPath, "price")}
                    />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label genericlabel">Quantity</label>
                    <input
                      type="number"
                      className="form-control"
                      value={node.quantity}
                      onChange={(e) => handleChange(e, currentPath, "quantity")}
                    />
                  </div>
                </div>

                <div className="d-flex justify-content-end mt-3">
                  <button
                    className="btn btn-outline-success w-25"
                    onClick={() => handleAddGroup(currentPath)}
                  >
                    Add Group
                  </button>
                </div>
              </div>
            </div>
          )}

          {node.elements && node.elements.length > 0 && (
            <div className="ms-4 mt-3">{renderTree(node.elements, currentPath)}</div>
          )}
        </div>
      );
    });
  };

  const [productIdVariantsData, setproductIdVariantsData] = useState([])
  // console.log("testingjob--->",productIdVariantsData)

  const getBrandList = async () => {
    try {
      setIsBrandLoading(true);
      const token = sessionStorage.getItem("token");
      const headers = {
        "x-custom-authorization": `Bearer ${token}`,
      };

      let response;
      try {
        response = await axios.get(`${apiEndpoint}/snp/brand/get`, { headers });
      } catch (err) {
        response = await axios.get(`${apiEndpoint}/snp/brand/get-all`, { headers });
      }

      const resData = response?.data;
      const list = resData?.data || resData?.brands || resData?.brand || (Array.isArray(resData) ? resData : []);
      setbrandlist(Array.isArray(list) ? list : []);
    } catch (error) {
      console.log("Get Brand List Error:", error);
    } finally {
      setIsBrandLoading(false);
    }
  };

  const handleBrandImageUpload = async (e) => {
    const files = e.target.files;
    if (!files || files.length === 0) return;
    const file = files[0];

    if (!file.type || !file.type.startsWith("image/")) {
      toast.error("Only image files (JPG, JPEG, PNG, WEBP, SVG) are allowed!");
      e.target.value = "";
      return;
    }

    const MAX_FILE_SIZE = 4 * 1024 * 1024;
    if (file.size > MAX_FILE_SIZE) {
      toast.error("Image size must be 4MB or less!");
      e.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("files", file);

    try {
      setBrandImageUploading(true);
      const token = sessionStorage.getItem("token");
      const { data } = await axios.post(
        `${apiEndpoint}/snp/upload`,
        formData,
        {
          headers: {
            "x-custom-authorization": `Bearer ${token}`,
          }
        }
      );

      if (data?.success && data?.urls && data.urls.length > 0) {
        toast.success(data.message || "Brand image uploaded successfully!");
        setNewBrandImage(data.urls[0]);
      } else {
        toast.error("Brand image upload failed!");
      }
    } catch (err) {
      console.error("Brand image upload failed:", err);
      toast.error("Brand image upload failed!");
    } finally {
      setBrandImageUploading(false);
      e.target.value = "";
    }
  };

  const handleCreateBrand = async () => {
    if (!newBrandName || !newBrandName.trim()) {
      toast.error("Please enter brand name!");
      return;
    }
    if (!newBrandImage || !newBrandImage.trim()) {
      toast.error("Please upload brand image!");
      return;
    }
    try {
      setIsBrandCreating(true);
      const token = sessionStorage.getItem("token");
      const imageUrl = newBrandImage ? newBrandImage.trim() : "";
      const { data } = await axios.post(
        `${apiEndpoint}/snp/brand/create`,
        {
          brand_name: newBrandName.trim(),
          image: imageUrl,
          images: imageUrl,
          brand_image: imageUrl,
          status: true
        },
        {
          headers: {
            "Content-Type": "application/json",
            "x-custom-authorization": `Bearer ${token}`,
            "Authorization": `Bearer ${token}`,
          }
        }
      );

      if (data?.status === true || data?.status === 200 || data?.success) {
        toast.success(data?.message || "Brand created successfully!");
        const brandObj = data?.data || data?.brand;
        const createdBrandValue = brandObj?.id || brandObj?.brand_name || newBrandName.trim();
        setIsCreateBrandModalOpen(false);
        setNewBrandName("");
        setNewBrandImage("");

        await getBrandList();
        setProduct((prev) => ({
          ...prev,
          brand: createdBrandValue,
          brand_id: brandObj?.id || createdBrandValue,
          brand_name: brandObj?.brand_name || newBrandName.trim()
        }));
        setProductErr((prev) => ({ ...prev, brand: false }));
      } else {
        toast.error(data?.message || "Failed to create brand");
      }
    } catch (error) {
      console.error("Create Brand Error:", error);
      toast.error(error?.response?.data?.message || "Failed to create brand");
    } finally {
      setIsBrandCreating(false);
    }
  };

  useEffect(() => {
    getBrandList();
    // taxListHanler(); categoryListing(); brandlisting(); getproductTypes()
    if (id) {
      // getProduct();
    } else {
      // getadditionaldetails()
    }
  }, []);

  console.log("pr-->", productIdVariantsData)
  const categoryListing = async () => {

    try {
      // const { data } = await axios({
      //   url: `${apiEndpoint}/getcategories`,
      //   method: "POST",
      //   headers: {
      //     "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
      //   },
      // });

      // if (data.status === 200) {
      //   setCategoryList(data.response);
      // }
    } catch (error) { }
  };


  async function getproductTypes() {

    try {

      const { data } = await axios({
        url: `${apiEndpoint}/getProtypeList`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },

      })

      if (data.status === 200) {
        setproductTypes(data?.data)

      } else {
        toast.error("Error In Loading Product Type");

      }
    } catch (err) {

      toast.error("Error in API")
    }
  }

  async function brandlisting() {

    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getBrandList`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      })

      if (data.status === 200) {
        setbrandlist(data.data)
      }
    } catch (err) {
      console.log(err)
    }
  }

  // async function getadditionaldetails() {

  //   const { data } = await axios({
  //     url: `${apiEndpoint}/sellerShop`,
  //     method: "POST",
  //     headers: {
  //       "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
  //     },

  //   });

  //   if (data.status === 200) {
  //     let adddata = data.response;
  //     setProduct({
  //       ...product, cod: adddata.cod, time_to_ship: adddata.time_to_ship, replaceable: adddata.replaceable, returnable: adddata.returnable, cancelable: adddata.cancelable, return_window: adddata.return_window,
  //       seller_pickup_return: adddata.seller_pickup_return
  //     })
  //   }
  // }

  const hasVariants = urlParams?.get('q');





  const [productTypeOptions, setProductTypeOptions] = useState([]);
  const [productTypeLoading, setProductTypeLoading] = useState(false);

  async function getProductTypeList() {
    setProductTypeLoading(true);
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/products/get-type`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      // console.log("datadfghj",data?.status)  

      if (data?.status == true || data?.status == 200 || data?.status == "200") {
        setProductTypeOptions(data?.data || []);


      } else {
        toast.error("Error loading product types");
      }
    } catch (err) {
      toast.error("Server not working, please try later!");
      console.log(err);
    } finally {
      setProductTypeLoading(false);
    }
  }

  async function getProductAttributes(productTypeId, existingValues = null) {
    if (!productTypeId) return;

    try {
      const { data } = await axios({
        url: `${apiEndpoint}/snp/products/get-attributes/${productTypeId}`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      console.log("Product attributes data:", data);
      const attrList = data?.data || data?.attributes || (Array.isArray(data) ? data : []);
      if ((data?.status === 200 || data?.status === true || data?.success || Array.isArray(attrList)) && Array.isArray(attrList) && attrList.length > 0) {
        setmanDatoryAttr(attrList);

        const initialAttributes = {};
        attrList.forEach((item) => {
          const attrName = item?.product_type_attribute || item?.mandatory_attribute || item?.attribute_name;
          if (attrName) {
            initialAttributes[attrName] = (existingValues && existingValues[attrName] !== undefined && existingValues[attrName] !== null)
              ? String(existingValues[attrName])
              : "";
          }
        });
        if (existingValues && typeof existingValues === "object") {
          Object.keys(existingValues).forEach((key) => {
            if (initialAttributes[key] === undefined || initialAttributes[key] === "") {
              initialAttributes[key] = String(existingValues[key]);
            }
          });
        }
        setmanDatoryAttrValue(initialAttributes);
      } else {
        setmanDatoryAttr([]);
        if (existingValues) {
          setmanDatoryAttrValue(existingValues);
        } else {
          setmanDatoryAttrValue({});
        }
      }
    } catch (err) {
      console.log("Error fetching product attributes:", err);
      setmanDatoryAttr([]);
      if (existingValues) {
        setmanDatoryAttrValue(existingValues);
      } else {
        setmanDatoryAttrValue({});
      }
    }
  }


  useEffect(() => {
    // categoryListing();
    // brandlisting();
    getProductTypeList();
    if (id) {
      // getProduct();
      // getVariantsData();
    }
  }, [id]);

  const getProduct = async () => {

    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getVarNonvarpro`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          "has_variation": hasVariants,
          "id": id
        },
      });

      console.log("data==>12", data)

      if (data.status === 200) {
        setDelivery(data?.data[0])

        if (hasVariants == "false") {
          let imageArray = data.data[0].image.split(",");
          setProduct({ ...data.data[0], image: imageArray });
          const features = JSON.parse(JSON.parse(data?.data[0]?.features));
          let mandatoryAttributes = Object.keys(features)?.map((item) => { return { mandatory_attribute: item } });
          setmanDatoryAttr([...mandatoryAttributes]);
          setmanDatoryAttrValue(features);
          setreadOnly(true);


        } else {
          setProduct({ ...data.data[0] });
          let { product_type, category_id } = data?.data[0];
          getMandAttribute(product_type, category_id)

        }

      }
    } catch (error) { }
  };

  const [isVariantsLoading, setisVariantsLoading] = useState(false)
  const [warehousePayload, setWarehousePayload] = useState(null);

  async function getVariantsData() {
    setisVariantsLoading(true);
    const targetId = queryParams.get("productId") || queryParams.get("id") || params?.id || productId || id;

    // 1. If already loaded from getProductById, open modal directly
    if (productIdVariantsData && productIdVariantsData.length > 0) {
      setisVariantsLoading(false);
      handleOpen();
      return;
    }
    if (product?.line_items && product.line_items.length > 0) {
      setproductIdVariantsData(product.line_items);
      setisVariantsLoading(false);
      handleOpen();
      return;
    }

    // 2. Fetch from GET /snp/products/get/:id
    if (targetId) {
      try {
        const response = await axios({
          url: `${apiEndpoint}/snp/products/get/${targetId}`,
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
          },
        });
        const variantsData = response?.data?.variants || [];
        if (variantsData.length > 0) {
          const lineItems = variantsData.map((v) => {
            const vAttrObj = {};
            if (Array.isArray(v?.attributes)) {
              v.attributes.forEach((a) => {
                if (a.attribute_name) {
                  vAttrObj[a.attribute_name] = a.attribute_value;
                }
              });
            }
            let parsedFeatures = {};
            if (v?.features) {
              try {
                parsedFeatures = typeof v.features === "string" ? JSON.parse(v.features) : v.features;
                if (typeof parsedFeatures === "string") {
                  parsedFeatures = JSON.parse(parsedFeatures);
                }
              } catch (e) {
                parsedFeatures = {};
              }
            }

            return {
              ...v,
              ...parsedFeatures,
              ...vAttrObj,
              id: v.id,
              variation_id: v.variation_id,
              sku: v.sku,
              gtin: v.gtin,
              hsn: v.hsn,
              image: v.image ? (typeof v.image === "string" ? v.image.split(",") : v.image) : [],
              uom: v.uom,
              uom_value: v.uom_value,
              weight: v.weights || v.weight,
              weights: v.weights || v.weight,
              maximum_price: v.price?.mrp || v.mrp || "",
              selling_price: v.price?.selling_price || v.selling_price || "",
              minimum_price: v.price?.min_price || v.price?.selling_price || "",
              base_price: v.price?.selling_price || "",
              tax_included_price: v.price?.selling_price || "",
              min_quantity: v.min_quantity,
              max_quantity: v.max_quantity,
              quantity: v.inventories?.[0]?.available_qty ?? v.quantity,
              available_qty: v.inventories?.[0]?.available_qty ?? v.quantity,
              returnable: v.fulfillment?.[0]?.returnable ?? v.returnable,
              cancelable: v.fulfillment?.[0]?.cancellable ?? v.fulfillment?.[0]?.cancelable ?? v.cancelable,
              replaceable: v.fulfillment?.[0]?.replaceable ?? v.replaceable,
              seller_pickup_return: v.fulfillment?.[0]?.seller_pickup_return,
              return_window: v.fulfillment?.[0]?.return_window,
              time_to_ship: v.fulfillment?.[0]?.time_to_ship,
              time_to_deliver: v.fulfillment?.[0]?.time_to_deliver,
              length: v.packing_details?.length?.value || vAttrObj.length || "",
              breadth: v.packing_details?.breadth?.value || vAttrObj.breadth || "",
              height: v.packing_details?.height?.value || vAttrObj.height || "",
              set: (typeof v.pack_config === "string" ? JSON.parse(v.pack_config) : v.pack_config)?.set ?? vAttrObj.set ?? vAttrObj.Set ?? "",
              case: (typeof v.pack_config === "string" ? JSON.parse(v.pack_config) : v.pack_config)?.case ?? vAttrObj.case ?? vAttrObj.Case ?? "",
              selling_unit: (typeof v.pack_config === "string" ? JSON.parse(v.pack_config) : v.pack_config)?.selling_unit ?? vAttrObj.selling_unit ?? vAttrObj["Selling Unit"] ?? "",
              variant_group: (v.attributes || []).map((a) => ({
                variant_name: a.attribute_name,
                variant_value: a.attribute_value,
                attr_id: a.id,
              })),
            };
          });

          setproductIdVariantsData(lineItems);
          setisVariantsLoading(false);
          handleOpen();
          return;
        }
      } catch (err) {
        console.log("Error loading variants from /snp/products/get:", err);
      }
    }

    // 3. Fallback to /getvardata
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getvardata`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: {
          "has_variation": true,
          "product_id": targetId || id
        }
      });

      if (data?.status === 200) {
        let modifiedData = data?.data?.map(item => {
          if (item?.features) {
            let { ...features } = item?.features;
            return { ...item, ...features };
          } else {
            return { ...item };
          }
        });
        setproductIdVariantsData(modifiedData);
        handleOpen();
      } else {
        handleOpen();
      }
    } catch (error) {
      handleOpen();
    } finally {
      setisVariantsLoading(false);
    }
  }
  const [inventoryDetails, setInventoryDetails] = useState([])
  const handleSubmitWareHouse = () => {
    let inventories = [];
    if (hideWarehouses) {
      inventories = data?.map((item) => ({
        warehouse_id: item.id,
        quantity: Number(sameQty)
      }));
    } else {
      inventories = data?.map((item) => ({
        warehouse_id: item.id,
        quantity: Number(warehouseQty[item.id] || 0)
      }));
    }

    setInventoryDetails(inventories)

  };


  const collectAttributes = (itemVariant, manDatoryAttrValue, productAttributes) => {
    const attrMap = new Map();

    const addAttr = (name, val) => {
      if (name && val !== undefined && val !== null && String(val).trim() !== "") {
        const keyStr = String(name).trim();
        const valStr = String(val).trim();
        if (keyStr && valStr) {
          attrMap.set(keyStr, valStr);
        }
      }
    };

    // 1. From manDatoryAttrValue object (dynamic attributes from API)
    if (manDatoryAttrValue && typeof manDatoryAttrValue === "object") {
      Object.entries(manDatoryAttrValue).forEach(([k, v]) => {
        addAttr(k, v);
      });
    }

    // 2. From itemVariant's variant_group if present (attributes selected from dropdowns/options)
    if (Array.isArray(itemVariant?.variant_group)) {
      itemVariant.variant_group.forEach((v) => {
        addAttr(v.variant_name || v.attribute_name, v.variant_value || v.attribute_value);
      });
    }

    // 3. From itemVariant's attributes array if present
    if (Array.isArray(itemVariant?.attributes)) {
      itemVariant.attributes.forEach((attr) => {
        addAttr(attr?.attribute_name, attr?.attribute_value);
      });
    }

    // 4. From productAttributes array if present
    if (Array.isArray(productAttributes)) {
      productAttributes.forEach((attr) => {
        addAttr(attr?.attribute_name, attr?.attribute_value);
      });
    }

    return Array.from(attrMap.entries()).map(([attribute_name, attribute_value]) => ({
      attribute_name,
      attribute_value,
    }));
  };

  const handleInput = async (e, operation) => {
    if (e) e.preventDefault();

    const targetId = queryParams.get("productId") || queryParams.get("id") || params?.id || productId || id;
    const isUpdate = operation === "update" || Boolean(targetId);

    let computedInventories = [];
    if (hideWarehouses) {
      computedInventories = data?.map((item) => ({
        warehouse_id: item.id,
        quantity: Number(sameQty) || 0
      })) || [];
    } else {
      computedInventories = (data || [])
        .filter((item) => selectedWarehouses[item.id] || selectedWarehouses[String(item.id)])
        .map((item) => ({
          warehouse_id: item.id,
          quantity: Number(warehouseQty[item.id] || warehouseQty[String(item.id)] || sameQty || 0)
        }));
      if (computedInventories.length === 0 && data?.length > 0) {
        computedInventories = [{
          warehouse_id: data[0].id,
          quantity: Number(sameQty) || 0
        }];
      }
    }

    const product_name = productTypes.filter((item) => item.id == product.product_type || item.id == product.product_type_id);
    const payload = buildPayload(product, [], product_name[0]?.name, computedInventories, manDatoryAttrValue, firstFilled, targetId);
    if (isUpdate) {
      delete payload.product_id;
    }
    console.log("FINAL SUBMIT PAYLOAD:", payload);

    // Mandatory field validations for General Information, Manufacture Details, Pricing, Other Details, and Inventory & Warehouse
    if (!product.name || String(product.name).trim() === "") {
      toast.error("Product Name can not be empty!");
      return;
    }
    if (!product.short_description || String(product.short_description).trim() === "") {
      toast.error("Short Description can not be empty!");
      return;
    }
    if (!product.long_description || String(product.long_description).trim() === "") {
      toast.error("Long Description can not be empty!");
      return;
    }
    if (!product.country_of_origin || String(product.country_of_origin).trim() === "") {
      toast.error("Country Of Origin can not be empty!");
      return;
    }
    if (!product.customer_care_number || String(product.customer_care_number).trim() === "") {
      toast.error("Customer Care Number can not be empty!");
      return;
    }
    if (String(product.customer_care_number).trim().length < 10 || String(product.customer_care_number).trim().length > 14) {
      toast.error("Customer Care Number must be between 10 and 14 digits!");
      return;
    }
    if (!product.category_id || String(product.category_id).trim() === "") {
      toast.error("Category can not be empty!");
      return;
    }
    if (!product.product_type_id && !product.product_type) {
      toast.error("Product Type can not be empty!");
      return;
    }

    // Validate dynamic product_type_attributes if is_mandatory is true
    if (Array.isArray(manDatoryAttr) && manDatoryAttr.length > 0) {
      for (const item of manDatoryAttr) {
        const isMandatory = Boolean(item?.is_mandatory ?? item?.is_mandate);
        const attrName = item?.product_type_attribute || item?.mandatory_attribute || item?.attribute_name;
        if (isMandatory && attrName) {
          const val = manDatoryAttrValue?.[attrName];
          if (val === undefined || val === null || String(val).trim() === "") {
            toast.error(`${attrName} can not be empty!`);
            return;
          }
        }
      }
    }
    if (!product.tags || String(product.tags).trim() === "") {
      toast.error("Tags can not be empty!");
      return;
    }

    const hasImage = Array.isArray(product.image) ? product.image.length > 0 : Boolean(product.image && String(product.image).trim());
    if (!hasImage) {
      toast.error("Please upload at least one Product Image!");
      return;
    }

    if (!product.pc_manufacturer_or_packer_name || String(product.pc_manufacturer_or_packer_name).trim() === "") {
      setProductErr((prev) => ({ ...prev, pc_manufacturer_or_packer_name: true }));
      toast.error("Manufacturer Name can not be empty!");
      return;
    }
    if (/^[0-9]/.test(String(product.pc_manufacturer_or_packer_name).trim())) {
      setProductErr((prev) => ({ ...prev, pc_manufacturer_or_packer_name: "invalid" }));
      toast.error("Manufacturer Name cannot start with a number!");
      return;
    }
    if (!product.pc_manufacturer_or_packer_address || String(product.pc_manufacturer_or_packer_address).trim() === "") {
      setProductErr((prev) => ({ ...prev, pc_manufacturer_or_packer_address: true }));
      toast.error("Manufacturer Address can not be empty!");
      return;
    }
    if (/[^a-zA-Z0-9\s,.\-/#]/.test(String(product.pc_manufacturer_or_packer_address))) {
      setProductErr((prev) => ({ ...prev, pc_manufacturer_or_packer_address: "invalid" }));
      toast.error("Invalid characters are not allowed in Manufacturer Address!");
      return;
    }
    const mfgYear = product.pc_month_year_of_manufacture_packing_import || product.pc_month_year_of_manufacturer_packing_import;
    if (!mfgYear || String(mfgYear).trim() === "") {
      toast.error("Manufacturing Year can not be empty!");
      return;
    }
    if (!product.pc_imported_product_country_of_origin || String(product.pc_imported_product_country_of_origin).trim() === "") {
      toast.error("Manufacture Country Of Origin can not be empty!");
      return;
    }
    if (!product.pc_common_or_generic_name_of_commodity || String(product.pc_common_or_generic_name_of_commodity).trim() === "") {
      toast.error("Common or Generic Name can not be empty!");
      return;
    }

    if (!product.time_to_ship || String(product.time_to_ship).trim() === "") {
      toast.error("Time to Ship can not be empty!");
      return;
    }
    if (product.returnable === undefined || product.returnable === null || String(product.returnable).trim() === "") {
      toast.error("Product Returnable can not be empty!");
      return;
    }
    if ((product.returnable === true || product.returnable === "true") && (!product.return_window || String(product.return_window).trim() === "")) {
      toast.error("Product Return Window can not be empty!");
      return;
    }
    if (product.cancelable === undefined || product.cancelable === null || String(product.cancelable).trim() === "") {
      toast.error("Product Cancellable can not be empty!");
      return;
    }
    if (product.seller_pickup_return === undefined || product.seller_pickup_return === null || String(product.seller_pickup_return).trim() === "") {
      toast.error("Return Pickup Available can not be empty!");
      return;
    }
    if (product.replaceable === undefined || product.replaceable === null || String(product.replaceable).trim() === "") {
      toast.error("Product Replaceable can not be empty!");
      return;
    }

    const rawBasePrice = product.base_price || product.maximum_price;
    if (rawBasePrice === undefined || rawBasePrice === null || String(rawBasePrice).trim() === "") {
      toast.error("Base Price / MRP can not be empty!");
      return;
    }
    const rawSellingPrice = product.selling_price || product.current_price;
    if (rawSellingPrice === undefined || rawSellingPrice === null || String(rawSellingPrice).trim() === "") {
      toast.error("Selling Price can not be empty!");
      return;
    }
    const basePriceNum = Number(rawBasePrice || 0);
    const sellingPriceNum = Number(rawSellingPrice || 0);
    if (sellingPriceNum > basePriceNum && basePriceNum > 0) {
      toast.error("Selling price cannot be greater than MRP price!", { toastId: "selling-price-mrp-error" });
      return;
    }
    if (product.tax === undefined || product.tax === null || String(product.tax).trim() === "") {
      toast.error("Tax / GST (%) can not be empty!");
      return;
    }
    if (product.tax_included === undefined || product.tax_included === null || String(product.tax_included).trim() === "") {
      toast.error("Tax Included can not be empty!");
      return;
    }

    if (!product.sku || String(product.sku).trim() === "") {
      toast.error("SKU Code can not be empty!");
      return;
    }
    if (!product.uom || String(product.uom).trim() === "") {
      toast.error("Unit Of Measurement can not be empty!");
      return;
    }
    if (!product.uom_value || String(product.uom_value).trim() === "") {
      toast.error("UOM Value can not be empty!");
      return;
    }
    if (!product.brand && !product.brand_id) {
      setProductErr((prev) => ({ ...prev, brand: true }));
      toast.error("Brand can not be empty!");
      return;
    }

    if (product.min_quantity === undefined || product.min_quantity === null || String(product.min_quantity).trim() === "") {
      toast.error("Minimum Quantity can not be empty!");
      return;
    }
    if (Number(product.min_quantity) <= 0) {
      toast.error("Minimum Quantity cannot be 0 or less!");
      return;
    }
    if (product.max_quantity === undefined || product.max_quantity === null || String(product.max_quantity).trim() === "") {
      toast.error("Maximum Quantity can not be empty!");
      return;
    }
    if (Number(product.max_quantity) <= 0) {
      toast.error("Maximum Quantity cannot be 0 or negative!");
      return;
    }
    if (Number(product.min_quantity) > Number(product.max_quantity)) {
      toast.error("Minimum Quantity cannot be greater than Maximum Quantity!");
      return;
    }

    if (!product.time_to_deliver || String(product.time_to_deliver).trim() === "") {
      toast.error("Time To Deliver can not be empty!");
      return;
    }

    if (product.cod_allowed === undefined || product.cod_allowed === null || String(product.cod_allowed).trim() === "") {
      toast.error("COD Allowed can not be empty!");
      return;
    }

    // Validate Warehouse selection & quantities for product creation
    if (!hideWarehouses && !isUpdate) {
      const activeWhIds = Object.keys(selectedWarehouses).filter((whId) => selectedWarehouses[whId]);
      if (activeWhIds.length === 0) {
        toast.error("Please select at least one Warehouse and add it to the table!");
        return;
      }
      for (const whId of activeWhIds) {
        const qty = warehouseQty[whId] !== undefined && warehouseQty[whId] !== "" ? warehouseQty[whId] : sameQty;
        if (qty === undefined || qty === null || String(qty).trim() === "" || isNaN(Number(qty)) || Number(qty) < 0) {
          const matchedWh = data?.find(w => String(w.id) === String(whId));
          toast.error(`Please enter a valid Quantity for warehouse "${matchedWh?.warehouse_name || whId}"!`);
          return;
        }
      }
    }

    try {
      setIsLoading(true);
      let urlPath = isUpdate ? `${apiEndpoint}/snp/products/update/${targetId}` : `${apiEndpoint}/snp/products/create`;
      const options = {
        method: isUpdate ? "PUT" : "POST",
        url: urlPath,
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: payload
      };
      const res = await axios(options);
      setIsLoading(false);
      if (res?.data?.status === false || res?.data?.success === false) {
        toast.error(res?.data?.message || "Operation failed !");
      } else if (res?.data?.status === 200 || res?.data?.status === "200" || res?.data?.status === true || res?.data?.success === true || (res.status === 200 && res?.data?.status !== false)) {
        toast.success(isUpdate ? "Product Updated successfully !" : "Product Created successfully !");
        setProduct(rawData);
        history.push("/instorecatalog");
      } else {
        toast.error(res?.data?.message || "Operation failed !");
      }
    } catch (error) {
      setIsLoading(false);
      console.log(error);
      const errMsg = error?.response?.data?.message || error?.response?.data?.error || "Server error, please try later !";
      toast.error(errMsg);
    }
  };

  const buildPayload = (product, lineItems, productTypeName, inventories, manDatoryAttrValue, firstFilled, targetId) => {
    const num = (v, d = 0) => {
      if (v === undefined || v === null || String(v).trim() === "") return d;
      const n = Number(v);
      return isNaN(n) ? d : n;
    };
    const toBool = (val, defaultVal = false) => {
      if (val === true || val === "true") return true;
      if (val === false || val === "false") return false;
      return defaultVal;
    };

    // UI mein "EB2B" dikhta hai, lekin API ko number chahiye, isliye EB2B => 1
    const CATEGORY_API_ID_MAP = { EB2B: 1 };

    const rawCategory = product.category_id;
    const categoryIdVal =
      CATEGORY_API_ID_MAP[rawCategory] !== undefined
        ? CATEGORY_API_ID_MAP[rawCategory]
        : (rawCategory !== "" && rawCategory !== undefined && !isNaN(Number(rawCategory)))
          ? Number(rawCategory)
          : 1;

    const productTypeVal = product.product_type_id || product.product_type;
    const brandRaw = product.brand_id || product.brand;
    const brandIdVal = brandRaw !== undefined && brandRaw !== "" && !isNaN(Number(brandRaw)) ? Number(brandRaw) : brandRaw;

    const productPayload = {
      name: (product.name || "").trim(),
      category_id: categoryIdVal,
      brand_id: brandIdVal,
      short_description: product.short_description || product.short_desc || "",
      long_description: product.long_description || "",
      tags: product.tags || "",
      product_type_id: productTypeVal ? Number(productTypeVal) : null,
      product_type_name: product.product_type_name || productTypeName || "",
      has_variations: false,
      country_of_origin: normalizeCountryCode(product.country_of_origin) || "IND",
      customer_care_number: product.customer_care_number || "",
      parent_id: product.parent_id || "",
      cms: product.cms || "",
      status: Boolean(product.status ?? true),
      pc_manufacturer_or_packer_name: product.pc_manufacturer_or_packer_name || "",
      pc_manufacturer_or_packer_address: product.pc_manufacturer_or_packer_address || "",
      pf_brand_owner_fssai_license_no: product.pf_brand_owner_fssai_license_no || product.pf_brand_owner_FSSAI_license_no || "",
      pc_common_or_generic_name_of_commodity: product.pc_common_or_generic_name_of_commodity || "",
      pc_month_year_of_manufacturer_packing_import:
        product.pc_month_year_of_manufacture_packing_import || product.pc_month_year_of_manufacturer_packing_import || "",
      pc_imported_product_country_of_origin: product.pc_imported_product_country_of_origin || product.country_of_origin || "India",
      tax: product.tax !== undefined && product.tax !== null && String(product.tax).trim() !== "" ? String(product.tax) : "0",
      tax_included: toBool(product.tax_included, true),
    };

    const payload = {
      ...(targetId ? { product_id: !isNaN(Number(targetId)) ? Number(targetId) : targetId } : {}),
      product: productPayload,
    };

    const buildVariantObj = (item) => {
      const activeItem = targetId ? { ...item, ...product } : item;

      // ---- price ----
      const basePrice = num(product.base_price ?? product.maximum_price ?? activeItem.base_price ?? activeItem.maximum_price ?? item.mrp);
      const currentPrice = num(product.selling_price ?? product.current_price ?? activeItem.selling_price ?? activeItem.current_price);
      const priceObj = {
        currency: activeItem.currency || "INR",
        base_price: basePrice,
        current_price: currentPrice,
        status: true,
      };

      // ---- packing ----
      const H = num(activeItem.packing_height ?? activeItem.height);
      const L = num(activeItem.packing_length ?? activeItem.length);
      const B = num(activeItem.packing_breadth ?? activeItem.breadth);
      const W = num(activeItem.packing_weight ?? activeItem.weight ?? activeItem.weights);
      const P = num(activeItem.packing_price, currentPrice || basePrice);

      const packingDetailsObj = {
        package_type: activeItem.package_type || "Gift Wrapped",
        dimensions: activeItem.dimensions || `${L} x ${B} x ${H} cm`,
        price: { unit: "INR", value: P },
        height: { unit: "cm", value: H },
        length: { unit: "cm", value: L },
        breadth: { unit: "cm", value: B },
        weight: { unit: "kg", value: W },
      };

      const pickFirst = (...vals) =>
        vals.find((v) => v !== undefined && v !== null && String(v).trim() !== "");

      const packConfigObj = {
        set: num(pickFirst(activeItem.set, activeItem.pack_config_set)),
        case: num(pickFirst(activeItem.case, activeItem.pack_config_case)),
        selling_unit: num(pickFirst(activeItem.selling_unit, activeItem.pack_config_selling_unit)),
      };

      // ---- features ----
      // API requirement: features must contain exactly ONE key-value pair
      // firstFilled = pehla filled attribute { key, value } from manDatoryAttrValue
      const featuresObj = {};
      if (firstFilled && firstFilled.key && firstFilled.value !== undefined && firstFilled.value !== null && String(firstFilled.value).trim() !== "") {
        featuresObj[firstFilled.key] = String(firstFilled.value).trim();
      }

      // ---- image ----
      const pickImg = (x) =>
        Array.isArray(x) ? (x[0] || "") : (typeof x === "string" ? x : "");
      const variantImg = pickImg(activeItem.image) || pickImg(item.image);

      // ---- inventories ----
      const sourceInvs =
        inventories?.length > 0 ? inventories
          : activeItem.inventories?.length > 0 ? activeItem.inventories
            : [];
      const formattedInventories = sourceInvs.map((inv) => ({
        warehouse_id: Number(inv.warehouse_id || inv.id),
        quantity: num(inv.quantity),
        status: Boolean(inv.status ?? true),
      }));

      const returnable = toBool(activeItem.returnable);

      return {
        weights: num(activeItem.weights ?? activeItem.weight ?? activeItem.packing_weight),
        sku: activeItem.sku || activeItem.seller_sku || "",
        hsn: activeItem.hsn || activeItem.hsn_code || "",
        image: variantImg,
        uom: activeItem.uom || "unit",
        uom_value: num(activeItem.uom_value, 1),
        max_quantity: num(activeItem.max_quantity, 100),
        min_quantity: num(activeItem.min_quantity, 1),
        features: featuresObj,
        packing_details: packingDetailsObj,
        pack_config: packConfigObj,
        price: priceObj,
        attributes: collectAttributes(activeItem, manDatoryAttrValue, product.attributes),
        returnable,
        cancellable: toBool(activeItem.cancellable ?? activeItem.cancelable),
        replaceable: toBool(activeItem.replaceable),
        seller_pickup_return: toBool(activeItem.seller_pickup_return),
        return_window: activeItem.return_window || product.return_window || "",
        time_to_ship: activeItem.time_to_ship || "",
        time_to_deliver: activeItem.time_to_deliver || "",
        cod_allowed: toBool(activeItem.cod_allowed),
        status: toBool(activeItem.status, true),
        inventories: formattedInventories,
      };
    };

    if (product.has_variations && product?.line_items?.length > 0) {
      payload.variants = product.line_items.map(buildVariantObj);
    } else {
      payload.variants = [buildVariantObj(product)];
    }

    return payload;
  };
  console.log("hello----", product)
  const [data, setData] = useState([])

  const getAllwarehouse = async () => {
    try {
      const response = await axios({
        url: `${apiEndpoint}/snp/warehouse/get`,
        method: 'GET',
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
      });
      const list = response?.data?.data || [];
      const activeList = Array.isArray(list)
        ? list.filter((item) => item?.status === true || item?.status === 1 || item?.status === "true")
        : [];
      setData(activeList);
    } catch (error) {
      console.log("Error -------->", error);
    }
  }

  useEffect(() => {
    getAllwarehouse();
  }, [])

  async function upDateVariantsHandler(tableData, variatType) {
    try {
      const prod = product || {};

      for (let i = 0; i < (tableData || []).length; i++) {
        const row = tableData[i];
        const mrpVal = Number(row.mrp ?? row.base_price ?? 0);
        const sellingVal = Number(row.selling_price ?? row.current_price ?? 0);
        if (sellingVal > mrpVal && mrpVal > 0) {
          toast.error(`Selling price cannot be greater than MRP price for Variant #${i + 1}!`, { toastId: "selling-price-mrp-error" });
          return;
        }
      }
      const formattedVariants = tableData?.map((item) => {
        // Build features object and attributes array
        const featuresObj = {};
        const attributesArr = [];

        if (Array.isArray(item?.variant_group)) {
          item.variant_group.forEach((vg) => {
            const name = vg?.variant_name || vg?.name || vg?.attribute_name;
            const val = vg?.variant_value || vg?.value || vg?.attribute_value;
            if (name && val !== undefined && val !== null && val !== "") {
              featuresObj[name] = String(val);
              attributesArr.push({
                attribute_name: String(name),
                attribute_value: String(val),
              });
            }
          });
        }

        if (item?.features && typeof item.features === "object") {
          if (Array.isArray(item.features)) {
            item.features.forEach((f) => {
              if (typeof f === "object" && f !== null) {
                Object.entries(f).forEach(([k, v]) => {
                  featuresObj[k] = String(v);
                  if (!attributesArr.some((a) => a.attribute_name === k)) {
                    attributesArr.push({ attribute_name: String(k), attribute_value: String(v) });
                  }
                });
              }
            });
          } else {
            Object.entries(item.features).forEach(([k, v]) => {
              featuresObj[k] = String(v);
              if (!attributesArr.some((a) => a.attribute_name === k)) {
                attributesArr.push({ attribute_name: String(k), attribute_value: String(v) });
              }
            });
          }
        }

        if (Array.isArray(item?.featuress)) {
          item.featuress.forEach((f) => {
            if (typeof f === "object" && f !== null) {
              Object.entries(f).forEach(([k, v]) => {
                featuresObj[k] = String(v);
                if (!attributesArr.some((a) => a.attribute_name === k)) {
                  attributesArr.push({ attribute_name: String(k), attribute_value: String(v) });
                }
              });
            }
          });
        }

        // Image URL extraction
        let imgVal = item?.image || item?.images || prod?.image || prod?.images || "";
        if (Array.isArray(imgVal)) {
          imgVal = imgVal.length > 0 ? (typeof imgVal[0] === "string" ? imgVal[0] : imgVal[0]?.url || imgVal[0]?.src || "") : "";
        } else if (typeof imgVal === "object" && imgVal !== null) {
          imgVal = imgVal.url || imgVal.src || "";
        }

        const basePrice = Number(item?.base_price || item?.maximum_price || item?.mrp || prod?.base_price || prod?.maximum_price || item?.selling_price || prod?.selling_price || 0);
        const currentPrice = Number(item?.selling_price || item?.current_price || prod?.selling_price || 0);
        const minPrice = Number(item?.min_price || item?.minimum_price || currentPrice || 0);
        const maxPrice = Number(item?.max_price || item?.maximum_price || basePrice || 0);
        const priceType = item?.price_type || item?.price?.price_type || "fixed";
        const weightVal = Number(item?.weights || item?.weight || prod?.weights || prod?.weight);

        const packingDetails = {
          price: { unit: "INR", value: Number(item?.packing_price || item?.packing_details?.price?.value || currentPrice) },
          height: { unit: item?.package_height_unit || item?.packing_details?.height?.unit || "cm", value: Number(item?.package_height || item?.height || item?.packing_details?.height?.value) },
          length: { unit: item?.package_length_unit || item?.packing_details?.length?.unit || "cm", value: Number(item?.package_length || item?.length || item?.packing_details?.length?.value) },
          weight: { unit: item?.package_weight_unit || item?.packing_details?.weight?.unit || "kg", value: Number(item?.package_weight || weightVal || 0.25) },
          breadth: { unit: item?.package_breadth_unit || item?.packing_details?.breadth?.unit || "cm", value: Number(item?.package_breadth || item?.breadth || item?.packing_details?.breadth?.value || 1) },
          category: item?.category || item?.packing_details?.category || prod?.category || "Grocery",
          dangerous_goods: Boolean(item?.dangerous_goods ?? item?.packing_details?.dangerous_goods ?? prod?.dangerous_goods ?? false),
        };

        const priceArr = Array.isArray(item?.price) && item.price.length > 0
          ? item.price
          : [
            {
              currency: "INR",
              base_price: basePrice,
              current_price: currentPrice,
              min_price: minPrice,
              max_price: maxPrice,
              price_type: priceType,
              status: true,
            },
          ];

        let inventoriesArr = [];
        if (Array.isArray(item?.inventories) && item.inventories.length > 0) {
          inventoriesArr = item.inventories.map((inv) => ({
            warehouse_id: Number(inv.warehouse_id || 1),
            quantity: Number(inv.quantity || 0),
            available_qty: Number(inv.available_qty ?? inv.quantity ?? 0),
            reserved_qty: Number(inv.reserved_qty || 0),
            safety_stock: Number(inv.safety_stock || 0),
            status: inv.status !== undefined ? Boolean(inv.status) : true,
          }));
        } else {
          const qty = Number(item?.quantity || item?.qty || prod?.quantity || 0);
          const whId = Number(item?.warehouse_id || prod?.warehouse_id || 1);
          inventoriesArr = [
            {
              warehouse_id: whId,
              quantity: qty,
              available_qty: qty,
              reserved_qty: 0,
              safety_stock: 0,
              status: true,
            },
          ];
        }

        const cleanDuration = (val, fallback) => {
          if (!val) return fallback;
          return String(val).replace(/^P/, "");
        };

        return {
          ...(item?.variation_id || item?.id ? { variation_id: String(item.variation_id || item.id) } : {}),
          sku: String(item?.sku || prod?.sku || `SKU-${Date.now()}`),
          gtin: String(item?.gtin || prod?.gtin || ""),
          hsn: String(item?.hsn || item?.hsn_code || prod?.hsn || prod?.hsn_code || ""),
          image: String(imgVal || ""),
          weights: weightVal,
          uom: String(item?.uom || prod?.uom || "piece"),
          uom_value: Number(item?.uom_value !== undefined && item?.uom_value !== null && String(item?.uom_value).trim() !== "" ? item.uom_value : (item?.weight || item?.weights || prod?.uom_value || 1)),
          max_quantity: Number(item?.max_quantity || item?.max_allowed_qty || prod?.max_quantity || prod?.max_allowed_qty || 10),
          min_quantity: Number(item?.min_quantity || item?.min_allowed_qty || prod?.min_quantity || prod?.min_allowed_qty || 1),
          features: featuresObj,
          packing_details: packingDetails,
          pack_config: {
            set: Number(item?.set ?? item?.pack_config?.set ?? 0) || 0,
            case: Number(item?.case ?? item?.pack_config?.case ?? 0) || 0,
            selling_unit: Number(item?.selling_unit ?? item?.pack_config?.selling_unit ?? 0) || 0,
          },
          price: priceArr,
          attributes: attributesArr,
          returnable: Boolean(item?.returnable ?? (prod?.returnable === "true" || prod?.returnable === true)),
          cancellable: Boolean(item?.cancellable ?? item?.cancelable ?? (prod?.cancelable === "true" || prod?.cancelable === true)),
          replaceable: Boolean(item?.replaceable ?? (prod?.replaceable === "true" || prod?.replaceable === true)),
          seller_pickup_return: Boolean(item?.seller_pickup_return ?? (prod?.seller_pickup_return === "true" || prod?.seller_pickup_return === true)),
          return_window: cleanDuration(item?.return_window || prod?.return_window,),
          time_to_ship: cleanDuration(item?.time_to_ship || prod?.time_to_ship,),
          time_to_deliver: cleanDuration(item?.time_to_deliver || prod?.time_to_deliver),
          cod_allowed: Boolean(item?.cod_allowed ?? (prod?.cod_allowed === "true" || prod?.cod_allowed === true)),
          status: item?.status !== undefined ? Boolean(item.status) : true,
          inventories: inventoriesArr,
        };
      });

      const payload = {
        variants: formattedVariants,
      };

      const targetId = id || product?.id;
      console.log("payload to update variants-------->", payload);
      const { data } = await axios({
        url: targetId ? `${apiEndpoint}/snp/products/add-product-variant/${targetId}` : `${apiEndpoint}/snp/products/add-product-variant`,
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        method: "POST",
        data: payload,
      });

      if (data?.status === 200 || data?.status === true || data?.success) {
        toast.success(data?.message || "Variants Updated Successfully");
      } else {
        toast.error(data?.message || "Something Went Wrong!");
      }

    } catch (err) {
      console.log(err);
      toast.error(err?.response?.data?.message || "Something Went Wrong!");
    }
  }

  async function restoreData() {
    setisVariantsLoading(true)
    try {

      setproductIdVariantsData(product?.line_items);
      handleOpen();

      setisVariantsLoading(false)

    } catch (error) {
      setisVariantsLoading(false)
    }
  }


  const handleImport = async () => {

    const reader = new FileReader();
    reader.onload = (e) => {
      const data = e.target.result;
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];
      const json = XLSX.utils.sheet_to_json(worksheet);
      console.log("json-------->", json)
      function commonFileds(item) {
        return {
          "variant_group_id": item?.variant_group_id,
          "name": item?.name,
          "pc_manufacturer_or_packer_name": item?.pc_manufacturer_or_packer_name,
          // "short_description": item.description,
          "description": item?.description,
          "tax": 0,//check
          "tags": item?.tags,
          // "hsn": item.hsn,
          "position": item?.position,
          "status": true,
          "returnable": item?.returnable,
          "cancelable": item?.cancelable,
          "return_window": item?.return_window,
          "seller_pickup_return": item?.seller_pickup_return,
          "time_to_ship": item?.time_to_ship,
          "cod": item?.cod,
          "product_type": item?.product_type,
          "product_type_name": item?.product_type_name,
          "pc_imported_product_country_of_origin": item?.pc_imported_product_country_of_origin,
          // "pf_brand_owner_FSSAI_license_no": item?.pf_brand_owner_FSSAI_license_no,
          "tax_included": item?.tax_included,
          "gtin": item?.gtin,
          "customer_care_contact": item?.customer_care_contact,
          "replaceable": item?.replaceable,
          "brand": item?.brand,
          "category_id": item?.category_id,
          "pc_common_or_generic_name_of_commodity": item?.pc_common_or_generic_name_of_commodity,
          "pc_manufacturer_or_packer_address": item?.pc_manufacturer_or_packer_address,
          "pc_month_year_of_manufacture_packing_import": item?.pc_month_year_of_manufacture_packing_import,
          "has_variations": item.has_variations,
          "features": item?.features,
          "size_chart": item?.size_chart,
          "fabric": item?.fabric,
        }
      }

      function lineItems(item) {
        return {
          "maximum_price": item?.maximum_price,
          "selling_price": item.selling_price,
          "quantity": item?.quantity,
          // "sku": item?.sku,
          "reference_id": item?.reference_id,
          "uom": item?.uom,
          "weight": item?.weight,
          "image": [item?.image],
          "variant_name": item?.variant_name,
          "variant_value": item?.variant_value
        }
      }
      let k = [];
      json.forEach((item) => {
        let v = k.some((product) => product.variant_group_id === item.variant_group_id);

        if (item.has_variations == true) {
          if (v) {
            let index = k.findIndex((obj) => obj.variant_group_id === item.variant_group_id);

            k[index].line_items.push({
              ...lineItems(item)
            })
          } else {
            k.push({
              ...commonFileds(item),
              "line_items": [
                {
                  ...lineItems(item)
                }
              ],
            })
          }
        } else {
          if (item.variant_group_id !== null) {
            k.push({ ...commonFileds(item) })
          }
        }

      })

      console.log("kkkk------", k)
      let dataToSend = json.filter(item => item.name !== null).map((item => {
        let tts = daysData.filter(items => items.name === item.time_to_ship)

        let rw = daysData.filter(items => items.name === item.return_window)

        let colourCode;
        if (item?.colour) {
          colourCode = ColourData.filter(items => items.name === item.colour);
        }



        return {
          // ...k
          // ...item,
          // time_to_ship: tts[0]?.value,
          // return_window: rw[0]?.value,
          // colour: colourCode ? colourCode[0]?.value : "#ffff",
          // colour_name: colourCode ? colourCode[0]?.name : "white"
        }
      }))
      sendDataToDb(dataToSend);
      // let jsonData = {
      //   orders: json
      // };
    };
    reader.readAsArrayBuffer(file);

  };
  const handleImportForProdXpressbazaar = async () => {
    try {
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, { header: 1 });

          // Get the headers from the first row of the sheet
          const headers = json[0];

          // Convert the rest of the sheet to JSON format
          const rows = XLSX.utils.sheet_to_json(worksheet);

          let errors = [];
          let dataToSend = rows.filter(item => item.name !== null).map((item) => {
            // Check for missing fields, excluding image2, image3, and image4
            const missingFields = headers.filter(header => {
              return (item[header] === null || item[header] === undefined) &&
                !['image1', 'image2', 'image3', 'image4', 'pf_brand_owner_FSSAI_license_no', 'transfer_price'].includes(header);
            });

            if (missingFields.length > 0) {
              const errorMessage = `Error in SKU: ${item.sku} - Missing fields: ${missingFields.join(', ')}`;
              errors.push(errorMessage);
              console.log(errorMessage);
              return null; // Skip this item in dataToSend
            }

            let tts = daysData.filter(items => items.name === item.time_to_ship);
            let rw = daysData.filter(items => items.name === item.return_window);
            let colourCode = item?.colour ? ColourData.filter(items => items.name === item.colour) : null;

            return {
              ...item,
              time_to_ship: tts[0]?.value,
              return_window: rw[0]?.value,
              // colour: colourCode ? colourCode[0]?.value : "#ffff",
              // colour_name: colourCode ? colourCode[0]?.name : "white"
            };
          }).filter(item => item !== null); // Filter out invalid items

          if (errors.length > 0) {

            const fileData = JSON.stringify(errors, null, 2);
            const blob = new Blob([fileData], { type: 'text/plain' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.download = 'error.txt';
            link.href = url;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            toast.error("Found error in excel! Error file is downloaded.")
          } else {
            sendDataToDb(dataToSend);
            console.log("datatosend -----------", dataToSend)
          }

        };
        reader.readAsArrayBuffer(file);
      }
    } catch (error) {
      console.error('Error handling import:', error.message);
    }
  };


  const handleFandBImport = async () => {
    try {
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          const data = e.target.result;
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const json = XLSX.utils.sheet_to_json(worksheet);
          let dataToSend = json.filter((item) => item.name !== null)
          // console.log("dataToSend----->", dataToSend)
          // return
          sendFandBDataToDb(dataToSend);

        };
        reader.readAsArrayBuffer(file);
      }

    } catch (error) {
      console.error('Error handling import:', error);
    }
  };

  async function sendFandBDataToDb(jsonData) {
    // let apiEndpoint = baseNodeapiUrl();
    console.log("jsonData---->", jsonData)
    const payload = {
      items: jsonData
    }
    // return
    try {

      let result = await axios({
        url: `${baseNodeapiUrl}/cms/customization/import-csv`,
        method: 'POST',
        headers: {
          "token": `${sessionStorage.getItem("token")}`,

        },
        data: payload,

      })

      console.log("result----->", result)


    } catch (error) {
      console.log(error)
      // toast.error(`${error?.response?.data?.error[0]?.message} for ${error?.response?.data?.error[0]?.email}`);
    }


  }


  //-----------------------  THIS THE NEW FNCTION TO IMPORT THE PRODUCT--------------------------------------------


  const handleImportMulti = async () => {

    // console.log(file)
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      complete: ({ data }) => {
        // console.log(data)
        let abc = data.filter(item => item.name !== null)
        let x = abc.map(item => {
          return {
            "name": item.name,
            "category_name": item.category_name,
            "product_type": item.product_type,
            // "short_description": item.short_description,
            "description": item.description,
            "image": item.image,
            "image1": item.image1,
            "image2": item.image2,
            "image3": item.image3,
            "image4": item.image4,
            "image5": item.image5,
            "image6": item.image6,
            "image7": item.image7,
            "tags": item.tags,
            "net_qty": item.net_qty,
            "quantity": item.quantity,
            "gtin": item.gtin,
            "product_type_name": item.product_type_name,
            "weight": item.weight,
            "brand": item.brand,
            "returnable": item.returnable,
            "cancelable": item.cancelable,
            "return_window": item.return_window,
            "seller_pickup_return": item.seller_pickup_return,
            "time_to_ship": item.time_to_ship,
            "cod": item.cod,
            "replaceable": item.replaceable,
            "maximum_price": item.maximum_price,
            "transfer_price": item.transfer_price,
            "selling_price": item.selling_price,
            "customer_care_contact": item.customer_care_contact,
            // "hsn": item.hsn,
            // "sku": item.sku,
            "tax": item.tax,
            "tax_included": item.tax_included,
            "tax_included_price": item.tax_included_price,
            "uom": item.uom,
            "gender": item.gender,
            "colour": item.colour,
            "size": item.size,
            "size_chart": item.size_chart,
            "fabric": item.fabric,
            "has_variations": item.has_variations,
            "pc_manufacturer_or_packer_name": item.pc_manufacturer_or_packer_name,
            "pc_common_or_generic_name_of_commodity": item.pc_common_or_generic_name_of_commodity,
            "pc_manufacturer_or_packer_address": item.pc_manufacturer_or_packer_address,
            "pc_imported_product_country_of_origin": item.pc_imported_product_country_of_origin,
            "features": item.features,
            "variant_group_id": item.variant_group_id
          }
        })

        // console.log("xxxxxxxxxxxx------>", x)
        sendDataToDb(x)
      },
    });
  };

  async function sendDataToDb(jsonData) {

    let apE;
    if (fullUrl === "multipleselleradmin.thesellerapp.com") {
      apE = "importProducts"
    } else {
      apE = "importxpProducts"
    }
    try {
      setLoading(true);
      let result = await axios({
        url: `${apiEndpoint}/${apE}`,
        method: 'POST',
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,

        },
        data: { "orders": jsonData },

      })
      setLoading(false);
      if (result.data.status == 200) {
        toast.success("Products added successfully !");
        setFile(null)
        document.getElementById('inputFile').value = ''
      } else {
        toast.error("Server Not Working, Please try later!");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Server Not Working, Please try later!");
    }


  }
  function handleShipementModalClose() {
    setshipmentModalOpen(false)
  }

  const errorHandler = (e) => {
    const { name, value } = e.target;
    if (!value || (typeof value === "string" && !value.trim())) {
      setProductErr({ ...productErr, [name]: true });
    } else if (name === "customer_care_number" && (String(value).trim().length < 10 || String(value).trim().length > 14)) {
      setProductErr({ ...productErr, [name]: "invalid_length" });
    } else if (name === "pc_manufacturer_or_packer_name" && /^[0-9]/.test(String(value).trim())) {
      setProductErr({ ...productErr, [name]: "invalid" });
    } else if (name === "pc_manufacturer_or_packer_address" && /[^a-zA-Z0-9\s,.\-/#]/.test(String(value))) {
      setProductErr({ ...productErr, [name]: "invalid" });
    } else {
      setProductErr({ ...productErr, [name]: false });
    }
  };

  const taxListHanler = async () => {

    try {
      const { data } = await axios({
        url: `${apiEndpoint}/gettaxlist`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      });
      // console.log("tax listing", data);
      if (data.status === 200) {
        setTaxData(data.data);
      }
    } catch (error) { }
  };

  const priceHandler = (e) => {
    // console.log("e.target.name", e.target.name);
    if (e.target.name === "selling_price") {
      const percentAmmount =
        (parseFloat(product.tax) / 100) * parseFloat(e.target.value);
      setProduct((preState) => ({
        ...preState,
        [e.target.name]: parseFloat(e.target.value),
        tax_included_price: product?.tax_included
          ? e.target.value
          : parseFloat(e.target.value) + parseFloat(percentAmmount.toFixed(4)),
      }));
    } else if (e.target.name === "tax") {
      const percentAmmount =
        (parseFloat(e.target.value) / 100) * parseFloat(product.selling_price);
      setProduct((preState) => ({
        ...preState,
        [e.target.name]: parseFloat(e.target.value),
        tax_included_price: product?.tax_included
          ? product?.tax_included_price
          : parseFloat(product.selling_price) +
          parseFloat(percentAmmount.toFixed(4)),
      }));
    } else if (e.target.name === "tax_included") {
      const percentAmmount =
        (parseFloat(product.tax) / 100) * parseFloat(product.selling_price);
      setProduct({
        ...product,
        [e.target.name]: !product?.tax_included,
        tax_included_price: !product?.tax_included
          ? product.selling_price
          : percentAmmount + parseFloat(product.selling_price),
      });
    }
  };



  const productImageHandler = async (e) => {
    const files = e.target.files;

    if (!files || files.length === 0) {
      toast.error("Please select an image file first!");
      return;
    }

    const file = files[0];

    // Validate that only image files are allowed
    if (!file.type || !file.type.startsWith("image/")) {
      toast.error("Only image files (JPG, JPEG, PNG, WEBP, SVG) are allowed!");
      e.target.value = "";
      return;
    }

    // Validate max file size (4MB = 4 * 1024 * 1024 bytes)
    const MAX_FILE_SIZE = 4 * 1024 * 1024;
    if (file.size > MAX_FILE_SIZE) {
      toast.error("Image size must be 4MB or less!");
      e.target.value = "";
      return;
    }

    // If an image is already present, silently do nothing for any additional upload
    if (product.image && product.image.length >= 1) {
      e.target.value = "";
      return;
    }

    const formData = new FormData();
    formData.append("files", file);

    try {
      const { data } = await axios.post(
        `${apiEndpoint}/snp/upload`,
        formData,
        {
          headers: {
            "x-custom-authorization": `Bearer ${sessionStorage.getItem('token')}`,
          }
        }
      );

      if (data?.success) {
        toast.success(data.message || "Upload successful!");
        console.log("Uploaded URLs:", data.urls);

        setProduct((prevProduct) => ({
          ...prevProduct,
          image: [...prevProduct.image, ...data.urls].slice(0, 1) // enforce max 1, just in case
        }));

      } else {
        toast.error("Upload failed!");
      }

    } catch (err) {
      console.error("Upload failed:", err);
      toast.error("Upload failed!");
    } finally {
      e.target.value = "";
    }
  };


  const preventMinus = (e) => {
    if (e.code === 'Minus') {
      e.preventDefault();
    }
  };
  async function submitFun(tableData, variantType, operation) {
    let line_items = tableData?.map((item) => ({ ...item, variant_group: item.variant_group }))
    setProduct({ ...product, line_items })
    toast.success("Variations Added!!")
  }


  function removeImageHandler(index, removeImageHandler) {
    // alert(index);
    let z = [...product.image]
    z.splice(index, 1)
    setProduct({ ...product, image: [...z] })
  }

  console.log("product--------->", product)

  const [optionValues, setoptionValues] = useState([0]);
  const [featureKeyValue, setfeatureKeyValue] = useState([{ code: "", value: "" }])

  function addHandler() {
    let x = [...optionValues, optionValues[optionValues.length - 1] + 1];
    setoptionValues((count) => [...count, count[count.length - 1] + 1]);

    setfeatureKeyValue((item) => [...item, { code: "", value: "" }])
  }

  function featureChangeHandler(index, e) {

    let z = [...featureKeyValue];
    z[index] = { ...z[index], [e.target.name]: e.target.value };
    setfeatureKeyValue([...z])
  }

  function onFeatureSaveHandler() {

    setProduct((prev) => {
      return { ...prev, features: JSON.stringify(featureKeyValue) }
    })

    toast.success("Feature Added! Please update the Product to save.")
  }


  const SizeChartImageHandler = async (e) => {

    try {
      const file = e.target.files[0];
      let myFile = file.name.split(".");
      let myFileType = myFile[myFile.length - 1];
      const s3 = new aws.S3({
        accessKeyId: "AKIAYJUL5VJOBYQMJDT7",
        secretAccessKey: "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"
      })
      const params = {
        Bucket: "ondc-marketplace",
        Key: `images/${uuidv4()}.${myFileType}`,
        Body: file,
        ContentType: file?.type
      }
      let result = await s3.upload(params).promise();
      const { Location } = result;


      // setallDynamicFiled((prev) => {
      //   return { ...prev, [e.target.name]: Location }
      // })

    } catch (exception) {
      toast.error("Error in Adding Image")
      console.log(exception);
    }
  };

  async function getSampleCsv() {

    try {

      const { data } = await axios({
        url: `${apiEndpoint}/download_product_csv`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: {
          "product_category": sampleCSVdata?.category,
          "product_type": sampleCSVdata?.product_type
        }
      })
      if (data?.status == "200") {
        const headers = Object.keys(data?.data[0]); // Use the keys of the first object as headers
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(data?.data, { header: headers });
        XLSX.utils.book_append_sheet(wb, ws, 'Orders');
        const fileName = `Sample_ProductSheet_${new Date().getTime()}.csv`;
        XLSX.writeFile(wb, fileName);
        toast.success("(CSV File downloaded, please fill the CSV file and import the products)");
        setdownloadCSVModalOpen(false);
        setSampleCSV({ category: "", product_type: "", sub_category: "", product_type_array: [] })
      } else {
        toast.error("CSV not present for this category at this time, Please try later!")
      }
    } catch (err) {
      toast.error("Server not working, please try later!")
      console.log(err)
    }
  }


  // async function getProductTypeforSelectedCategory(id) {

  //   try {

  //     const { data } = await axios({
  //       url: `${apiEndpoint}/get_product_types`,
  //       method: "POST",
  //       headers: {
  //         "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
  //       },
  //       data: {
  //         product_category_name: id
  //       }
  //     })
  //     if (data?.status == "200") {
  //       setSampleCSV((prev) => {
  //         return { ...prev, product_type_array: data?.data }
  //       })
  //     }
  //   } catch (err) {
  //     toast.error("Server not working, please try later!")
  //     console.log(err)
  //   }

  // }

  function determineSizeFilter() {
    if (sampleCSVdata.sub_category == "Formal Shoes" || sampleCSVdata.sub_category == "Casual Shoes" || sampleCSVdata.sub_category == "Sports Shoes" || sampleCSVdata.sub_category == "Boots" || sampleCSVdata.sub_category == "Outdoor Shoes" || sampleCSVdata.sub_category == "Work & Safety Shoes" || sampleCSVdata.sub_category == "Ethnic Shoes" || sampleCSVdata.sub_category == "Sandals & Floaters") {
      let shoeData = ShoeSizedata.map(name => ({ name }));
      return shoeData
    }

    if (sampleCSVdata?.gender_specification === "male" || sampleCSVdata?.gender_specification === "female") {
      let size = SizeData.map(name => ({ name }));
      return size
    }

    if (sampleCSVdata?.gender_specification === "boy" || sampleCSVdata?.gender_specification === "girl") {

      let size = SizeDataBoyGirl.map(name => ({ name }));
      return size

    }
  }


  let colours = ColourData.map(item => ({ name: item?.name }));
  let fabrics = FabricData.map(name => ({ name }));
  let uom = UOMData.map(name => ({ name }));
  let material = MaterialData.map(name => ({ name }));

  const mockStoreData = [
    { options: [{ name: "true" }, { name: "false" }] },
    { options: [{ name: '1 Day' }, { name: '2 Days' }, { name: '3 Days' }, { name: '4 Days' }, { name: '5 Days' }, { name: '6 Days' }, { name: '7 Days' }, { name: '8 Days' }, { name: '9 Days' }, { name: '10 Days' }] },
    { options: [...colours] },
    { options: determineSizeFilter() },
    { options: [{ name: "male" }, { name: "female" }, { name: "boy" }, { name: "girl" }, { name: "unisex" }, { name: "infant" }] },
    { options: [...fabrics] },
    { options: [...uom] },
    { options: [...material] },
    { options: [{ name: "yes" }, { name: "no" }] }
  ];
  const generateTemplate = async () => {
    try {
      const response = await axios({
        url: `${apiEndpoint}/snp/download/sample-csv`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: {
          "product_category_id": sampleCSVdata?.category,
          "product_type_name": sampleCSVdata?.product_type
        },
        responseType: "blob"   // ✅ binary file expect karo, JSON nahi
      });

      // Seedha blob se download trigger karo
      const blob = new Blob([response.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      });
      const excelUrl = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = excelUrl;
      link.download = `product_sample_${sampleCSVdata?.category}_${sampleCSVdata?.sub_category}.xlsx`;
      document.body.appendChild(link);
      link.click();
      URL.revokeObjectURL(excelUrl);
      document.body.removeChild(link);

      toast.success("Excel file downloaded, please fill it and import the products");
      setdownloadCSVModalOpen(false);
      setSampleCSV({ category: "", product_type: "", sub_category: "", product_type_array: [] });

    } catch (err) {
      toast.error("Server not working, please try later!");
      console.log(err);
    }
  };

  async function getProductTypeOnCategory(id) {
    try {
      setLoading(true)
      const { data } = await axios({
        url: `${apiEndpoint}/getProductTypeid`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: {
          product_category_id: parseInt(id)
        }
      })
      if (data && (data.status === 200 || data.status === "200" || Number(data.status) === 200)) {
        setproductTypes(data?.data)
      } else {
        toast.error("Error In Loading Product Type");
      }
      // if (data?.status == "200") {
      //   setSampleCSV((prev) => {
      //     return { ...prev, product_type_array: data?.data }
      //   })
      // }
      setLoading(false)
    } catch (err) {
      toast.error("Server not working, please try later!")
      console.log(err)
    }

  }

  const getCategoryOption = async (e) => {
    setCategoryOption(e.target.selectedOptions[0].text)
  }

  const [manDatoryAttr, setmanDatoryAttr] = useState([]);
  const [manDatoryAttrValue, setmanDatoryAttrValue] = useState({})

  // features m sirf EK attribute (pehla jo filled ho) jayega
  const getFirstFilledAttr = (obj) => {
    const entry = Object.entries(obj).find(
      ([key, value]) => value !== null && value !== undefined && String(value).trim() !== ""
    );
    return entry ? { key: entry[0], value: entry[1] } : null;
  };
  const firstFilled = getFirstFilledAttr(manDatoryAttrValue);
  async function getMandAttribute(value, parent_category_id) {
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/listmandattr`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: {
          "parent_category_id": id ? parent_category_id : product?.category_id,
          // "product_type_id": parseInt(value)
        }
      })
      if (data?.status == "200") {
        setmanDatoryAttr(data?.response);
        const initialAttributes = data?.response.reduce((acc, curr) => {
          acc[curr.mandatory_attribute] = "";
          return acc;
        }, {});

        // Set initial state
        setmanDatoryAttrValue(initialAttributes);
      }
    } catch (err) {
      toast.error("Server not working, please try later!")
      console.log(err)
    }

  }

  async function deletHandlerWhileCreate(indexItem, index) {
    handleClose();
    let v = product?.line_items;
    let updatedTableData = [...v];
    updatedTableData.splice(index, 1);
    setProduct((prev) => { return { ...prev, line_items: updatedTableData } })

  }

  // useEffect(() => {
  //   const categoryId = product?.category_id;
  //   categoryId && getProductTypeOnCategory(categoryId);
  // }, [product?.category_id]);

  function addMoreHandler() {
    let z = attributesState?.data?.map(item => {
      if (!item.price && !item.start_date && !item.end_date) {
        return { ...item, price: attributesState?.price, start_date: attributesState?.start_date, end_date: attributesState?.end_date, maximum_price: attributesState?.maximum_price }
      } else {
        return { ...item }
      }

    })
    setattributeState((prev) => { return { ...prev, stateName: "", price: "", data: [...z], start_date: "", end_date: "", maximum_price: "" } });
    setSelectedODays();
  }

  async function submitHandler(operation) {
    try {
      let z
      if (operation === "Update") {
        z = attributesState?.data?.map(item => {
          if (item.state_name === attributesState?.editing_attr_id) {
            return {
              ...item, price: attributesState?.editing_attr_value, start_date: attributesState.start_date, end_date: attributesState?.end_date, maximum_price: attributesState?.maximum_price
            }
          } else {
            return item
          }
        })
      } else {
        z = attributesState?.data?.map(item => {
          if (!item.price) {
            return { ...item, price: attributesState?.price, start_date: attributesState.start_date, end_date: attributesState?.end_date, maximum_price: attributesState?.maximum_price }
          } else {
            return { ...item }
          }

        })
      }

      setattributeState((prev) => { return { ...prev, stateName: "", price: "", data: [...z], editing_attr_id: "", editing_attr_value: "", start_date: "", end_date: "", submitting: true, maximum_price: "" } });
      setSelectedODays();
      // let apiEndpoint = baseUrlDefiner();
      const { data } = await axios({
        url: `${apiEndpoint}/priceruleproduct`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: {
          "allproducts": [
            {
              "id": id,
              "status": attributesState?.status,
              "has_variation": hasVariants === "true" ? true : false,
              "state": "Delhi",
              "compare_at_price": attributesState?.maximum_price,
              "selling_price": [...z],
              "validation_date": {
                "start_date": "2024-09-30",
                "end_date": "2024-09-31"
              }
            }]
        }
      })

      if (data?.status === 200) {
        toast.success("Added Successfully!");
      } else {
        toast.error("Something went wrong, please try later!")
      }
      setattributeState((prev) => { return { ...prev, submitting: false, } });

      console.log("data--------", data)
    } catch (err) {
      setattributeState((prev) => { return { ...prev, submitting: false, } });
      toast.error("Server error, please try later!")
    }
  }

  const onSelectHandler = (selectedList, selectedItem) => {
    console.log("selectedList-------", selectedList);
    console.log("selectedODays-------", selectedODays);
    let z = selectedList.map(item => { return { state_name: item.value } })
    setattributeState((prev) => {
      return {
        ...prev, data: [...prev.data, { state_name: selectedItem.value }],
      }
    })

    setSelectedODays(selectedList.map(item => item));
    // let daySelected = selectedList.map(item => item.id);
    // let z = daySelected.toString()

  }
  const onRemoveHandler = (selectedList, selectedItem) => {
    console.log("selectedList-------", selectedList)
    // let daySelected = selectedList.map(item => item.id);
    // let z = daySelected.toString()
    setSelectedODays(selectedList.map(item => item));
  }

  async function getStateBasedPriceData(id) {
    // let apiEndpoint = baseUrlDefiner();
    let payload;

    if (hasVariants === "true") {
      payload = {
        "variantid": "3baca8ba-44d2-4e64-9368-8ef44f1a1fef"
      }
    }

    if (hasVariants === "false") {
      payload = {
        "productid": product?.ondc_product_id

      }
    }
    try {
      const { data } = await axios({
        url: `${apiEndpoint}/getpriceruleproduct`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
        },
        data: payload
      })

      if (data?.status === 200) {
        setattributeState((prev) => {
          return { ...prev, status: data?.data[0]?.status, maximum_price: data?.data[0]?.compare_at_price, data: JSON.parse(data?.data[0]?.selling_price) }
        })
      }

      console.log(data)

    } catch (err) {
      toast.error("Server not working, please try later!")
      console.log(err)
    }
  }

  async function updateStatePriceRuleHandler() {
    let indexOfItem = attributesState?.data?.findIndex(item => item?.state_name === attributesState?.stateName);
    let z = [...attributesState?.data];
    z[indexOfItem] = { ...z[indexOfItem], price: attributesState?.price, start_date: attributesState.start_date, end_date: attributesState?.end_date, maximum_price: attributesState?.maximum_price };
    setattributeState((prev) => {
      return { ...prev, data: [...z], submitting: true, }
    })

    setSelectedODays();
    // let apiEndpoint = baseUrlDefiner();
    const { data } = await axios({
      url: `${apiEndpoint}/priceruleproduct`,
      method: "POST",
      headers: {
        "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`
      },
      data: {
        "allproducts": [
          {
            "id": id,
            "status": attributesState?.status,
            "has_variation": hasVariants === "true" ? true : false,
            "state": "Delhi",
            "compare_at_price": attributesState?.maximum_price,
            "selling_price": [...z],
            "validation_date": {
              "start_date": "2024-09-30",
              "end_date": "2024-09-31"
            }
          }]
      }
    })

    if (data?.status === 200) {
      toast.success("Updated Successfully!");
      setattributeState((prev) => { return { ...prev, stateName: "", price: "", data: [...z], editing_attr_id: "", editing_attr_value: "", start_date: "", end_date: "", submitting: false, maximum_price: "" } });
    } else {
      toast.error("Something went wrong, please try later!")
    }


    // setattributeState((prev) => {
    //   return {...prev, data: prev.data}
    // })
  }

  // console.log("attributeState--------", attributesState)
  console.log("product?.category_id--------", product?.category_id)
  console.log("treeData--------", treeData)


  const [loadingsync, setLoadingsync] = useState(false);
  const [loadingsyncproduct, setLoadingsyncproduct] = useState(false);

  const handleSync = async () => {
    try {
      setLoadingsync(true);

      const token = sessionStorage.getItem("token");


      const { data } = await axios({
        url: `${apiEndpoint}/products`,
        method: "GET",
        headers: {
          "x-custom-authorization": `Bearer ${token}`,
        },
      });

      console.log("Sync Response:", data);

      toast.success("Products synced successfully!");
    } catch (error) {
      console.error("Sync failed:", error);
      toast.error("Failed to sync products. Please try again.");
    } finally {
      setLoadingsync(false);
    }
  };

  useEffect(() => {
    const syncing = sessionStorage.getItem("syncingInProgress");
    if (syncing === "true") {
      setLoadingsyncproduct(true);
    }
  }, []);

  const handleSyncproduct = async () => {
    try {
      setLoadingsyncproduct(true);
      sessionStorage.setItem("syncingInProgress", "true");
      const token = sessionStorage.getItem("token");
      const { data } = await axios({
        url: `${apiEndpoint}/products/import`,
        method: "POST",
        headers: {
          "x-custom-authorization": `Bearer ${token}`,
        },
      });

      console.log("Sync Response:", data);

      toast.success("Products synced successfully!");
    } catch (error) {
      console.error("Sync failed:", error);
      toast.error("Failed to sync products. Please try again.");
    } finally {
      setLoadingsyncproduct(false);
      sessionStorage.removeItem("syncingInProgress");
    }
  };

  const [vendorName, setVendorName] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);

  const downloadURL =
    `${apiEndpoint}/storage/shopify_products_20251014_115812.csv`;

  const handleDownloadClick = () => {
    if (product.seller_id === 2) {
      setIsModalOpen(true);
    } else {
      handleDownload();
    }
  };

  // Trigger download with vendor name
  const handleDownload = () => {
    const payload = {
      vendor_name: vendorName,
    };
    console.log("Payload sent:", payload);

    // Download file
    const link = document.createElement("a");
    link.href = downloadURL;
    link.download = downloadURL.split("/").pop();
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Close modal after download
    setIsModalOpen(false);
  };



  const [openAntModal, setOpenAntModal] = useState(false);

  // File state & ref for bulk upload
  const [fileAntModal, setFileAntModal] = useState(null);
  const bulkFileInputRef = useRef(null);

  const resetBulkUploadFile = () => {
    setFileAntModal(null);
    if (bulkFileInputRef.current) {
      bulkFileInputRef.current.value = "";
    }
  };

  // --- Modal handlers ---
  const handleOpenAntModal = () => {
    resetBulkUploadFile();
    setOpenAntModal(true);
  };

  const handleCloseAntModal = () => {
    resetBulkUploadFile();
    setOpenAntModal(false);
  };

  const handleOkAntModal = () => {
    resetBulkUploadFile();
    setOpenAntModal(false);
  };

  // --- File handlers ---
  const handleFileChange = (e) => {
    if (!e.target.files || e.target.files.length === 0) return;
    const selectedFile = e.target.files[0];

    const allowedTypes = [
      "text/csv",
      "application/pdf",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    ];

    if (!allowedTypes.includes(selectedFile.type)) {
      alert("Please select a CSV, PDF, or Excel file!");
      resetBulkUploadFile();
      return;
    }

    setFileAntModal(selectedFile);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!fileAntModal) {
      alert("Please select a file first!");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileAntModal);

    const token = sessionStorage.getItem("token");

    try {
      const response = await axios.post(
        `${apiEndpoint}/snp/products/create-bulk`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            "X-Custom-Authorization": `Bearer ${token}`,
          },
        }
      );

      console.log("Bulk upload response:", response.data);

      const isSuccess = response?.data?.success || response?.data?.status === true || response?.data?.status === 200 || response?.status === 200;

      if (isSuccess) {
        const successCount = response.data?.success_count ?? response.data?.data?.success_count ?? 0;
        const failedCount = response.data?.failed_count ?? response.data?.data?.failed_count ?? 0;
        alert(
          `File uploaded successfully! Processed: ${successCount}, Skipped: ${failedCount}`
        );
        resetBulkUploadFile();
        if (e.target && typeof e.target.reset === "function") {
          e.target.reset();
        }
        setOpenAntModal(false); // auto-close modal on success
      } else {
        alert(response?.data?.message || "File upload failed. Check server response.");
        resetBulkUploadFile();
      }
    } catch (error) {
      console.error("Upload failed:", error);
      alert(error?.response?.data?.message || "File upload failed!");
      resetBulkUploadFile();
    }
  };




  useEffect(() => {
    if (deliverycheck) {
      setProduct((prev) => ({
        ...prev,
        sellers_charges: Boolean(deliverycheck?.sellers_charges),
        delivery_charges: deliverycheck?.delivery_charges || 0,
        selling_price: deliverycheck?.selling_price || prev.selling_price,
      }));
    }
  }, [deliverycheck]);

  const [buyerdata, setBuyerdata] = useState([]);



  useEffect(() => {
    // sendBuyerApps();
  }, []);

  const sendBuyerApps = async () => {
    try {
      const response = await axios.get(
        `${apiEndpoint}/buyerapp-name `
      );

      setBuyerdata(response?.data?.data);
      console.log("Buyer App Data:", response?.data?.data);

    } catch (error) {
      console.error("API Error:", error);
    }
  };


  const otherOptions = [
    {
      key: '1',
      label: (
        <div>
          <span className="text-center"
            onClick={() => { setdownloadCSVModalOpen(true) }}  >Download Sample Excel </span>
        </div>
      ),
    },
    {
      key: '2',
      label: (
        <div>
          <span onClick={handleOpenAntModal}  >
            Upload File
          </span>
        </div>
      ),
    },
    // {
    //   key: '3',
    //   label: (
    //     <div>
    //       {hasVariants !== "true" && <span className="text-center" onClick={() => { setStateBasedPriceingopen(true); getStateBasedPriceData(id) }}>Price rule</span>}

    //     </div>
    //   ),
    // },

  ];


  const handleAttributeChange = (index, field, value) => {
    const updatedAttributes = [...product.attributes];
    updatedAttributes[index][field] = value;
    setProduct({
      ...product,
      attributes: updatedAttributes,
    });
  };

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const productId = queryParams.get("productId") || id;
  const [pdpData, setPdpData] = useState([]);

  useEffect(() => {
    const targetId = queryParams.get("productId") || queryParams.get("id") || params?.id;
    if (targetId) {
      getProductById(targetId);
    } else {
      setProduct(rawData);
      setProductErr(rawDataError);
      setmanDatoryAttrValue({});
      setSelectedWarehouses({});
      setWarehouseQty({});
    }
  }, [location.search, params?.id]);

  const getProductById = async (targetId) => {
    const pId = targetId || productId || id;
    if (!pId) return;
    try {
      const response = await axios({
        url: `${apiEndpoint}/snp/products/get/${pId}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
      });

      const productData = response?.data?.product?.[0];
      const variantsData = response?.data?.variants || [];

      if (!productData) return;

      const firstVariant = variantsData?.[0];

      // Attributes map from firstVariant attributes and features
      const attrObj = {};
      if (Array.isArray(firstVariant?.attributes)) {
        firstVariant.attributes.forEach((a) => {
          const name = (a.attribute_name || a.name || "").trim();
          const val = (a.attribute_value !== undefined && a.attribute_value !== null ? String(a.attribute_value) : (a.value || "")).trim();
          if (name) {
            attrObj[name] = val;
          }
        });
      }
      if (firstVariant?.features) {
        let parsedFeat = firstVariant.features;
        if (typeof parsedFeat === "string") {
          try { parsedFeat = JSON.parse(parsedFeat); } catch (e) { }
        }
        if (parsedFeat && typeof parsedFeat === "object" && !Array.isArray(parsedFeat)) {
          Object.keys(parsedFeat).forEach((key) => {
            if (parsedFeat[key] !== undefined && parsedFeat[key] !== null) {
              attrObj[key] = String(parsedFeat[key]).trim();
            }
          });
        }
      }
      setmanDatoryAttrValue(attrObj);

      const productTypeVal = productData.product_type_id || productData.product_type || "";
      if (productTypeVal) {
        getProductAttributes(productTypeVal, attrObj);
      }

      // Warehouses map from firstVariant.inventories
      const newSelectedWarehouses = {};
      const newWarehouseQty = {};
      if (Array.isArray(firstVariant?.inventories) && firstVariant.inventories.length > 0) {
        firstVariant.inventories.forEach((inv) => {
          if (inv.warehouse_id !== undefined && inv.warehouse_id !== null) {
            const whId = String(inv.warehouse_id);
            newSelectedWarehouses[whId] = true;
            newWarehouseQty[whId] = inv.available_qty !== undefined && inv.available_qty !== null ? String(inv.available_qty) : (inv.quantity !== undefined && inv.quantity !== null ? String(inv.quantity) : "");
          }
        });
      }
      setSelectedWarehouses(newSelectedWarehouses);
      setWarehouseQty(newWarehouseQty);
      setTempSelectedWarehouses([]);
      setTempWarehouseQty("");

      // Har variant ko line_items row mein convert karo (edit-mode variants table ke liye)
      const lineItems = variantsData.map((v) => {
        const vAttrObj = {};
        if (Array.isArray(v?.attributes)) {
          v.attributes.forEach((a) => {
            if (a.attribute_name) {
              vAttrObj[a.attribute_name] = a.attribute_value;
            }
          });
        }
        return {
          id: v.id,
          variation_id: v.variation_id,
          sku: v.sku,
          gtin: v.gtin,
          hsn: v.hsn,
          image: v.image ? [v.image] : [],
          uom: v.uom,
          weight: v.weights || v.weight,
          maximum_price: v.price?.mrp,
          selling_price: v.price?.selling_price,
          minimum_price: v.price?.min_price || v.price?.selling_price,
          base_price: v.price?.selling_price,
          min_quantity: v.min_quantity,
          max_quantity: v.max_quantity,
          quantity: v.inventories?.[0]?.available_qty,
          returnable: v.fulfillment?.[0]?.returnable,
          cancelable: v.fulfillment?.[0]?.cancellable ?? v.fulfillment?.[0]?.cancelable,
          replaceable: v.fulfillment?.[0]?.replaceable,
          seller_pickup_return: v.fulfillment?.[0]?.seller_pickup_return,
          return_window: v.fulfillment?.[0]?.return_window,
          time_to_ship: v.fulfillment?.[0]?.time_to_ship,
          time_to_deliver: v.fulfillment?.[0]?.time_to_deliver,
          cod_allowed: v.fulfillment?.[0]?.cod_allowed,
          length: v.packing_details?.length?.value || vAttrObj.length,
          breadth: v.packing_details?.breadth?.value || vAttrObj.breadth,
          height: v.packing_details?.height?.value || vAttrObj.height,
          packing_price: v.packing_details?.price?.value || vAttrObj.packing_price,
          set: (typeof v.pack_config === "string" ? JSON.parse(v.pack_config) : v.pack_config)?.set ?? vAttrObj.set ?? vAttrObj.Set ?? "",
          case: (typeof v.pack_config === "string" ? JSON.parse(v.pack_config) : v.pack_config)?.case ?? vAttrObj.case ?? vAttrObj.Case ?? "",
          selling_unit: (typeof v.pack_config === "string" ? JSON.parse(v.pack_config) : v.pack_config)?.selling_unit ?? vAttrObj.selling_unit ?? vAttrObj["Selling Unit"] ?? "",
          variant_group: (v.attributes || []).map((a) => ({
            variant_name: a.attribute_name,
            variant_value: a.attribute_value,
            attr_id: a.id,
          })),
        };
      });

      const brandVal = productData.brand_id || productData.brand || firstVariant?.features?.Brand || attrObj?.Brand || "";

      setProduct((prev) => ({
        ...prev,
        name: productData.name || "",
        short_description: productData.short_description || "",
        long_description: productData.long_description || "",
        country_of_origin: normalizeCountryCode(productData.country_of_origin) || "IND",
        customer_care_number: productData.customer_care_number || "",
        category_id: productData.category_id || "",
        brand_id: brandVal,
        brand: brandVal,
        product_type_id: productTypeVal,
        product_type: productTypeVal,
        product_type_name: productData.product_type_name || "",
        has_variations: Boolean(productData.has_variations),
        status: productData.status ?? true,
        tags: productData.tags || "",
        tax: productData.tax !== undefined && productData.tax !== null ? String(productData.tax) : "",
        tax_included: productData.tax_included !== undefined && productData.tax_included !== null ? Boolean(productData.tax_included) : true,
        pc_manufacturer_or_packer_name: productData.pc_manufacturer_or_packer_name || "",
        pc_manufacturer_or_packer_address: productData.pc_manufacturer_or_packer_address || "",
        pc_month_year_of_manufacture_packing_import: productData.pc_month_year_of_manufacturer_packing_import || productData.pc_month_year_of_manufacture_packing_import || "",
        pc_imported_product_country_of_origin: productData.pc_imported_product_country_of_origin || productData.country_of_origin || "India",
        pc_common_or_generic_name_of_commodity: productData.pc_common_or_generic_name_of_commodity || "",
        pf_brand_owner_FSSAI_license_no: productData.pf_brand_owner_fssai_license_no || productData.pf_brand_owner_FSSAI_license_no || "",

        // Single product / variant base fields
        sku: firstVariant?.sku || "",
        hsn: firstVariant?.hsn || "",
        gtin: firstVariant?.gtin || "",
        uom: firstVariant?.uom || "",
        uom_value: firstVariant?.uom_value || "",
        weight: firstVariant?.weights || firstVariant?.weight || "",
        image: firstVariant?.image ? [firstVariant.image] : (productData.image ? (Array.isArray(productData.image) ? productData.image : [productData.image]) : []),
        maximum_price: firstVariant?.price?.mrp || firstVariant?.price?.max_price || firstVariant?.price?.base_price || "",
        selling_price: firstVariant?.price?.selling_price || firstVariant?.price?.current_price || "",
        base_price: firstVariant?.price?.base_price || firstVariant?.price?.mrp || firstVariant?.price?.selling_price || "",
        minimum_price: firstVariant?.price?.min_price || firstVariant?.price?.selling_price || "",
        min_quantity: firstVariant?.min_quantity || "",
        max_quantity: firstVariant?.max_quantity || "",

        // Fulfillment / Shipping
        returnable: String(firstVariant?.fulfillment?.[0]?.returnable ?? "true"),
        cancelable: String(firstVariant?.fulfillment?.[0]?.cancellable ?? firstVariant?.fulfillment?.[0]?.cancelable ?? "true"),
        replaceable: String(firstVariant?.fulfillment?.[0]?.replaceable ?? "true"),
        seller_pickup_return: String(firstVariant?.fulfillment?.[0]?.seller_pickup_return ?? "true"),
        return_window: firstVariant?.fulfillment?.[0]?.return_window || prev.return_window,
        time_to_ship: firstVariant?.fulfillment?.[0]?.time_to_ship || prev.time_to_ship,
        time_to_deliver: firstVariant?.fulfillment?.[0]?.time_to_deliver || prev.time_to_deliver,
        cod_allowed: String(firstVariant?.fulfillment?.[0]?.cod_allowed ?? "true"),

        // Dimensions & Packing
        packing_price: firstVariant?.packing_details?.price?.value || firstVariant?.packing_price || attrObj.packing_price || "",
        packing_height: firstVariant?.packing_details?.height?.value || firstVariant?.packing_height || firstVariant?.height || attrObj.height || "",
        packing_length: firstVariant?.packing_details?.length?.value || firstVariant?.packing_length || firstVariant?.length || attrObj.length || "",
        packing_breadth: firstVariant?.packing_details?.breadth?.value || firstVariant?.packing_breadth || firstVariant?.breadth || attrObj.breadth || "",
        packing_weight: firstVariant?.packing_details?.weight?.value || firstVariant?.packing_weight || firstVariant?.weights || firstVariant?.weight || "",
        height: firstVariant?.packing_details?.height?.value || attrObj.height || "",
        length: firstVariant?.packing_details?.length?.value || attrObj.length || "",
        breadth: firstVariant?.packing_details?.breadth?.value || attrObj.breadth || "",
        dangerous_goods: String(firstVariant?.packing_details?.dangerous_goods ?? attrObj.dangerous_goods ?? "false"),
        set: (typeof firstVariant?.pack_config === "string" ? JSON.parse(firstVariant.pack_config) : firstVariant?.pack_config)?.set ?? attrObj.set ?? attrObj.Set ?? "",
        case: (typeof firstVariant?.pack_config === "string" ? JSON.parse(firstVariant.pack_config) : firstVariant?.pack_config)?.case ?? attrObj.case ?? attrObj.Case ?? "",
        selling_unit: (typeof firstVariant?.pack_config === "string" ? JSON.parse(firstVariant.pack_config) : firstVariant?.pack_config)?.selling_unit ?? attrObj.selling_unit ?? attrObj["Selling Unit"] ?? "",
        pack_config_set: (typeof firstVariant?.pack_config === "string" ? JSON.parse(firstVariant.pack_config) : firstVariant?.pack_config)?.set ?? firstVariant?.pack_config_set ?? attrObj.set ?? attrObj.Set ?? "",
        pack_config_case: (typeof firstVariant?.pack_config === "string" ? JSON.parse(firstVariant.pack_config) : firstVariant?.pack_config)?.case ?? firstVariant?.pack_config_case ?? attrObj.case ?? attrObj.Case ?? "",
        pack_config_selling_unit: (typeof firstVariant?.pack_config === "string" ? JSON.parse(firstVariant.pack_config) : firstVariant?.pack_config)?.selling_unit ?? firstVariant?.pack_config_selling_unit ?? attrObj.selling_unit ?? attrObj["Selling Unit"] ?? "",

        line_items: lineItems,
        attributes: firstVariant?.attributes || [],
      }));

      // Preload variants data for the Variants modal
      if (lineItems && lineItems.length > 0) {
        setproductIdVariantsData(lineItems);
      }

    } catch (error) {
      console.log("Error fetching product:", error);
    }
  };

  const [isLoading, setIsLoading] = useState(false);
  const updateProductHandler = async () => {
    setIsLoading(true);
    try {
      const targetId = queryParams.get("productId") || queryParams.get("id") || params?.id || productId || id;
      const payload = {
        product: {
          name: product.name,
          image: product.image?.join(",") || "",
          // short_description: product.short_description,

          long_description: product.long_description,
          category_id: product.category_id,
          // product_type_id: product.product_type,
          brand_id: product.brand_id,
          pc_manufacturer_or_packer_name: product.pc_manufacturer_or_packer_name,
          pc_manufacturer_or_packer_address: product.pc_manufacturer_or_packer_address,
          pc_month_year_of_manufacturer_packing_import: product.pc_month_year_of_manufacture_packing_import,
          pc_imported_product_country_of_origin: product.pc_imported_product_country_of_origin,
          pc_common_or_generic_name_of_commodity: product.pc_common_or_generic_name_of_commodity,
          tax: product.tax !== undefined && product.tax !== null && String(product.tax).trim() !== "" ? String(product.tax) : "0",
          tax_included: product.tax_included !== undefined && product.tax_included !== null ? Boolean(product.tax_included) : true,
          // seller_level_feature: product?.seller_level_feature
        },
        // variant: {
        //   hsn: product.hsn
        // }
      };
      const response = await axios({
        url: `${apiEndpoint}/snp/products/update/${targetId}`,
        method: "PUT",
        headers: {
          "content-type": "application/json",
          "x-custom-authorization": `Bearer ${sessionStorage.getItem("token")}`,
        },
        data: payload
      });
      toast.success(response?.data?.message);
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      console.log("Error ------->", error);
    }
  };

  useEffect(() => {
    getProductById();
  }, [])

  return (
    <ThemeMaker>
      {isLoading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(255, 255, 255, 0.75)",
            zIndex: 99999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            backdropFilter: "blur(3px)"
          }}
        >
          <Spin size="large" />
          <div style={{ marginTop: "16px", fontWeight: 700, fontSize: "16px", color: "#105293" }}>
            {(queryParams.get("productId") || queryParams.get("id") || params?.id || productId || id)
              ? "Updating Product, please wait..."
              : "Creating Product, please wait..."}
          </div>
        </div>
      )}
      <style>{`
        .genericlabel {
          font-size: 13px !important;
          font-weight: 600 !important;
          color: #334155 !important;
          margin-bottom: 6px !important;
          display: inline-block !important;
        }

        .modalTrigerButton {
          background-color: #FFF7ED !important;
          color: #EA580C !important;
          border: 1.5px solid #FDBA74 !important;
          border-radius: 8px !important;
          padding: 4px 12px !important;
          font-size: 12.5px !important;
          font-weight: 700 !important;
          cursor: pointer !important;
          transition: all 0.2s !important;
          display: inline-flex !important;
          align-items: center !important;
          gap: 6px !important;
          float: right !important;
          text-decoration: none !important;
        }

        .modalTrigerButton:hover {
          background-color: #FFEDD5 !important;
          color: #C2410C !important;
          border-color: #FB923C !important;
          transform: translateY(-1px);
        }

        .tiny_size {
          font-size: 11.5px !important;
          font-weight: 600 !important;
          margin-left: 4px !important;
        }

        .text-danger {
          color: #EF4444 !important;
        }

        .btn-create-product {
          background: linear-gradient(135deg, #F97316 0%, #EA580C 100%) !important;
          border: none !important;
          color: #FFFFFF !important;
          border-radius: 10px !important;
          padding: 10px 28px !important;
          font-weight: 700 !important;
          font-size: 14px !important;
          box-shadow: 0 4px 14px rgba(249, 115, 22, 0.35) !important;
          transition: all 0.2s ease !important;
        }

        .btn-create-product:hover {
          box-shadow: 0 6px 20px rgba(249, 115, 22, 0.45) !important;
          transform: translateY(-1px);
        }

        .btn-update-product {
          background: linear-gradient(135deg, #10B981 0%, #059669 100%) !important;
          border: none !important;
          color: #FFFFFF !important;
          border-radius: 10px !important;
          padding: 10px 28px !important;
          font-weight: 700 !important;
          font-size: 14px !important;
          box-shadow: 0 4px 14px rgba(16, 185, 129, 0.35) !important;
          transition: all 0.2s ease !important;
        }

        .btn-update-product:hover {
          box-shadow: 0 6px 20px rgba(16, 185, 129, 0.45) !important;
          transform: translateY(-1px);
        }
        .form-group {
          margin-bottom: 16px !important;
        }

        .form-control,
        select.form-control,
        input.form-control:not(.ant-select-selection-search-input) {
          height: 44px !important;
          line-height: 1.5 !important;
          padding: 8px 14px !important;
          font-size: 13.5px !important;
          font-weight: 500 !important;
          border-radius: 10px !important;
          border: 1.5px solid #E2E8F0 !important;
          background-color: #F8FAFC !important;
          color: #1E293B !important;
          box-sizing: border-box !important;
          transition: all 0.2s ease !important;
          width: 100% !important;
        }

        .form-control:focus,
        select.form-control:focus,
        input.form-control:not(.ant-select-selection-search-input):focus {
          background-color: #FFFFFF !important;
          border-color: #F97316 !important;
          box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.14) !important;
          outline: none !important;
        }

        .form-control:hover,
        select.form-control:hover,
        input.form-control:not(.ant-select-selection-search-input):hover {
          border-color: #CBD5E1 !important;
        }

        textarea.form-control {
          height: auto !important;
          min-height: 80px !important;
          padding: 10px 14px !important;
          line-height: 1.5 !important;
        }

        /* Ant Design Select Perfect Reset & Style */
        .ant-select-single:not(.ant-select-customize-input) .ant-select-selector {
          height: 44px !important;
          border-radius: 10px !important;
          border: 1.5px solid #E2E8F0 !important;
          background-color: #F8FAFC !important;
          padding: 0 14px !important;
          display: flex !important;
          align-items: center !important;
          box-shadow: none !important;
          transition: all 0.2s ease !important;
        }

        .ant-select-single:not(.ant-select-customize-input):hover .ant-select-selector {
          border-color: #CBD5E1 !important;
        }

        .ant-select-focused:not(.ant-select-disabled).ant-select:not(.ant-select-customize-input) .ant-select-selector {
          border-color: #F97316 !important;
          box-shadow: 0 0 0 3px rgba(249, 115, 22, 0.14) !important;
          background-color: #FFFFFF !important;
        }

        .ant-select-single .ant-select-selector .ant-select-selection-search {
          display: flex !important;
          align-items: center !important;
          inset-inline-start: 14px !important;
          inset-inline-end: 14px !important;
        }

        .ant-select-single .ant-select-selector .ant-select-selection-search-input,
        .ant-select-single input.ant-select-selection-search-input,
        .ant-select input {
          border: none !important;
          background: transparent !important;
          background-color: transparent !important;
          box-shadow: none !important;
          outline: none !important;
          height: 42px !important;
          padding: 0 !important;
          margin: 0 !important;
          border-radius: 0 !important;
          font-size: 13.5px !important;
        }

        .ant-select-single .ant-select-selector .ant-select-selection-item,
        .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
          line-height: 42px !important;
          font-size: 13.5px !important;
          color: #1E293B !important;
          padding: 0 !important;
        }

        .ant-select-single .ant-select-selector .ant-select-selection-placeholder {
          color: #94A3B8 !important;
        }

        .ant-select-arrow {
          color: #64748B !important;
        }
      `}</style>
      <div className="row w-100 m-0 mt-1" >
        <div className="col-md-12">
          <div className="mb-3 p-3 bg-white border d-flex justify-content-between align-items-center flex-wrap" style={{ borderRadius: "16px", borderColor: "#E5E7EB", backgroundColor: "#ffffff", boxShadow: "0 10px 30px rgba(15, 23, 42, 0.04)", position: "sticky", top: "10px", zIndex: 30, padding: "18px 24px" }}>
            <div>
              <h5 className="m-0 font-weight-bold text-dark d-flex align-items-center" style={{ fontSize: "1.3rem", letterSpacing: "-0.3px", color: "#0F172A" }}>
                {id ? "Edit Product Details" : "Add New Product"}
              </h5>
              <small style={{ fontSize: "13px", color: "#64748B" }}>
                {id ? "Update your product details, shipping & inventory information" : "Fill out the required information to list a new product in your store"}
              </small>
            </div>
            {!id && (
              <div className="d-flex align-items-center" style={{ gap: "12px" }}>
                <button
                  type="button"
                  className="btn btn-sm font-weight-bold d-flex align-items-center text-white shadow-sm"
                  style={{ borderRadius: "10px", fontSize: "13px", gap: "8px", backgroundColor: "#F97316", border: "none", height: "40px", padding: "0 16px" }}
                  onClick={() => setdownloadCSVModalOpen(true)}
                >
                  <i className="fas fa-file-excel"></i>
                  Download Sample Excel
                </button>
                <button
                  type="button"
                  className="btn btn-sm font-weight-bold d-flex align-items-center shadow-sm"
                  style={{ borderRadius: "10px", fontSize: "13px", gap: "8px", borderColor: "#F97316", color: "#F97316", backgroundColor: "#FFF7ED", border: "1.5px solid #F97316", height: "40px", padding: "0 16px" }}
                  onClick={handleOpenAntModal}
                >
                  <i className="fas fa-file-upload"></i>
                  Upload File
                </button>
              </div>
            )}
          </div>
          <>
            <div className="card-body p-0" style={{ overflowY: "auto", maxHeight: "calc(100vh - 160px)" }}  >
              <div className="row">
                <div className="col-md-12 pl-2 pr-2">
                  <div className=' pt-2'>
                    <div className={styles.productContainer}>
                      <div className={styles.leftpart} style={id ? { width: "100%", maxWidth: "100%" } : {}}>
                        <div className={styles.whiteContainer}>
                          <div className="col-md-12">
                            <h3><FiInfo style={{ color: "#F97316", marginRight: "10px", fontSize: "19px" }} /> General Information</h3>
                          </div>
                          {/* <div className="col-md-6">
                              <div className="form-group">
                                <label className='genericlabel'>Select inventory type</label>
                                <span className="text-danger" > * </span>
                                <select name="seller_level_feature" id="" className='form-control' value={product?.seller_level_feature}
                                  onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value, })} onBlur={(e) => errorHandler(e)}  >
                                  <option value="" disabled selected>Select type</option>
                                  <option value="inventory_less">Inventoryless</option>
                                  <option value="default">Defalut</option>
                                  <option value="both">Both</option>

                                </select>
                                {
                                  productErr?.uom ? (
                                    <span className="text-danger tiny_size" > This field is required ! </span>
                                  ) : null
                                }
                              </div>
                            </div> */}
                          <div className="col-md-12">
                            <div className="form-group">
                              <label className='genericlabel'>Product Name </label>
                              <span className="text-danger" > * </span>
                              <input type="text" className="form-control" id="" name="name"
                                value={product.name}
                                onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value.trimStart(), })}

                                onBlur={(e) => errorHandler(e)} placeholder="Enter Product Name" />                                {
                                productErr?.name ? (
                                  <span className="text-danger tiny_size" > This field is required ! </span>
                                ) : null
                              }
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <label className='genericlabel'> Short Description </label>
                              <span className="text-danger"> * </span>
                              <textarea className="form-control" name="short_description" value={product.short_description || ""}
                                rows={2}
                                maxLength={255}
                                onChange={(e) => setProduct({
                                  ...product,
                                  [e.target.name]: e.target.value.replace(/[!@#$%^&*]/g, "").slice(0, 255)
                                })}
                                placeholder="Enter Short Product Description"
                              />
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="form-group">
                              <label className='genericlabel'> Long Description </label>
                              <span className="text-danger" > * </span>
                              <textarea type="text" className="form-control" name="long_description" value={product.long_description || ""}
                                rows={3}
                                maxLength={500}
                                onChange={(e) => setProduct({
                                  ...product,
                                  [e.target.name]: e.target.value.replace(/[!@#$%^&*]/g, "").slice(0, 500)
                                })} onBlur={(e) => errorHandler(e)} placeholder="Enter Long Product Description"
                              />
                              {
                                productErr?.long_description ? (
                                  <span className="text-danger tiny_size" > This field is required ! </span>
                                ) : null
                              }
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label className='genericlabel'> Country Of Origin </label>
                              <span className="text-danger"> * </span>
                              <input
                                type="text"
                                className="form-control"
                                name="country_of_origin"
                                value={product.country_of_origin ?? "IND"}
                                onChange={(e) => {
                                  setProduct({
                                    ...product,
                                    country_of_origin: normalizeCountryCode(e.target.value)
                                  });
                                }}
                                onBlur={(e) => {
                                  setProduct({
                                    ...product,
                                    country_of_origin: normalizeCountryCode(e.target.value) || "IND"
                                  });
                                }}
                                onKeyDown={(e) => {
                                  if (e.ctrlKey || e.metaKey) return;
                                  if (
                                    !/[a-zA-Z\s]/.test(e.key) &&
                                    !["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  setProduct({
                                    ...product,
                                    country_of_origin: normalizeCountryCode(e.clipboardData.getData("text"))
                                  });
                                }}
                                placeholder="Enter Product Country Of Origin"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="form-group">
                              <label className='genericlabel'> Customer Care Number </label>
                              <span className="text-danger"> * </span>
                              <input type="text" className="form-control" name="customer_care_number" value={product.customer_care_number || ""}
                                onChange={(e) => {
                                  const val = e.target.value.replace(/[^0-9]/g, "").slice(0, 14);
                                  setProduct({ ...product, [e.target.name]: val });
                                  if (productErr?.customer_care_number) {
                                    if (val.length >= 10 && val.length <= 14) {
                                      setProductErr((prev) => ({ ...prev, customer_care_number: false }));
                                    }
                                  }
                                }}
                                onWheel={(e) => e.target.blur()}
                                onBlur={(e) => errorHandler(e)}
                                onKeyDown={(e) => {
                                  if (e.ctrlKey || e.metaKey) return;
                                  // "-", "+", "e", "E", ".", " " explicitly block karo, plus koi bhi non-digit
                                  const blockedKeys = ["-", "+", "e", "E", ".", " "];
                                  if (
                                    blockedKeys.includes(e.key) ||
                                    (!/[0-9]/.test(e.key) &&
                                      !["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key))
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onPaste={(e) => {
                                  // Paste karte waqt bhi non-digit hata do
                                  e.preventDefault();
                                  const pasted = e.clipboardData.getData("text");
                                  const cleaned = pasted.replace(/[^0-9]/g, "").slice(0, 14);
                                  setProduct({ ...product, customer_care_number: cleaned });
                                  if (productErr?.customer_care_number) {
                                    if (cleaned.length >= 10 && cleaned.length <= 14) {
                                      setProductErr((prev) => ({ ...prev, customer_care_number: false }));
                                    }
                                  }
                                }}
                                placeholder="Enter Customer Care Number (e.g. 18001234567)"
                                maxLength={14}
                              />
                              {productErr?.customer_care_number === true ? (
                                <span className="text-danger tiny_size">This field is required !</span>
                              ) : productErr?.customer_care_number === "invalid_length" ? (
                                <span className="text-danger tiny_size">Customer Care Number must be between 10 and 14 digits!</span>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label className='genericlabel'>Category</label>
                              <span className="text-danger"> * </span>
                              <select
                                name="category_id"
                                value={product?.category_id || ""}
                                onChange={(e) => {
                                  const selectedValue = e.target.value;
                                  setProduct({
                                    ...product,
                                    category_id: selectedValue
                                  });
                                  // getProductTypeOnCategory(selectedValue);
                                  getCategoryOption(e);
                                }}
                                onBlur={(e) => errorHandler(e)}
                                className="form-control"
                              >
                                <option value="" disabled>Select Category</option>
                                <option value="EB2B">EB2B</option>
                                {categoryList.map(item => (
                                  <option key={item.id} value={item.id}>{item.cat_name}</option>
                                ))}
                              </select>
                              {productErr?.category_id ? (
                                <span className="text-danger tiny_size">This field is required !</span>
                              ) : null}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <div className='d-flex justify-content-between align-item-center'>
                                <div>
                                  <label className=" genericlabel">Product Type</label>
                                  <span className="text-danger" > * </span>
                                </div>
                                {productTypeLoading ? (
                                  <Box>
                                    <CircularProgress size={20} />
                                  </Box>
                                ) : null}
                              </div>

                              <Select
                                showSearch={!id}
                                style={{ width: "100%", pointerEvents: id ? "none" : "auto", background: id ? "#f5f5f5" : "" }}
                                placeholder="Select Product Type"
                                value={product.product_type_name || undefined}
                                optionFilterProp="children"
                                disabled={!!id}
                                open={id ? false : undefined}
                                filterOption={(input, option) =>
                                  (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                                }
                                onChange={(value, option) => {
                                  if (id) return;
                                  setProduct({
                                    ...product,
                                    product_type_id: value,
                                    product_type_name: option?.children,
                                    product_type: value,
                                  });
                                  if (value) {
                                    getProductAttributes(value);
                                  }
                                }}
                                onBlur={() => {
                                  setProductErr({ ...productErr, product_type: !product.product_type_id });
                                }}
                              >
                                {productTypeOptions?.map(item => (
                                  <Select.Option key={item.id} value={item.id}>
                                    {item.name}
                                  </Select.Option>
                                ))}
                              </Select>

                              {productErr?.product_type ? (
                                <span className="text-danger tiny_size">This field is required !</span>
                              ) : null}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <div>
                                  <label className='genericlabel mb-0'>Brand</label>
                                  <span className="text-danger"> * </span>
                                </div>
                                <span
                                  className="text-primary"
                                  style={{ fontSize: "12px", fontWeight: 600, cursor: "pointer" }}
                                  onClick={() => setIsCreateBrandModalOpen(true)}
                                >
                                  + Create New Brand
                                </span>
                              </div>
                              <div className="d-flex align-items-center" style={{ gap: "8px" }}>
                                <select
                                  className={`form-control ${productErr?.brand ? "is-invalid border-danger" : ""}`}
                                  value={product.brand || product.brand_id || ""}
                                  name="brand"
                                  onFocus={getBrandList}
                                  onClick={getBrandList}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    const found = brandlist.find(item => String(item.id || item.brand_name) === String(val));
                                    setProduct({
                                      ...product,
                                      brand: val,
                                      brand_id: found?.id || val,
                                      brand_name: found?.brand_name || val
                                    });
                                    if (val) {
                                      setProductErr((prev) => ({ ...prev, brand: false }));
                                    } else {
                                      setProductErr((prev) => ({ ...prev, brand: true }));
                                    }
                                  }}
                                  onBlur={(e) => errorHandler(e)}
                                >
                                  <option value="">Select Brand</option>
                                  {brandlist.map((item, idx) => (
                                    <option value={item.id || item.brand_name} key={item.id || idx}>
                                      {item.brand_name || item.name}
                                    </option>
                                  ))}
                                </select>
                                <button
                                  type="button"
                                  className="btn btn-outline-secondary btn-sm"
                                  title="Refresh Brands"
                                  onClick={getBrandList}
                                  disabled={isBrandLoading}
                                  style={{ height: "38px", padding: "0 12px", borderRadius: "6px" }}
                                >
                                  <FiRefreshCcw className={isBrandLoading ? "fa-spin" : ""} size={14} />
                                </button>
                              </div>
                              {productErr?.brand ? (
                                <span className="text-danger tiny_size">This field is required !</span>
                              ) : null}
                            </div>
                          </div>

                          <div className="col-md-6 col-sm-12">
                            <div className="form-group">
                              <label className='genericlabel'>Tags</label>
                              <span className="text-danger"> * </span>
                              <input
                                type="text"
                                className="form-control"
                                name="tags"
                                value={product.tags || ""}
                                onChange={(e) => {
                                  setProduct({ ...product, [e.target.name]: e.target.value });
                                }
                                }
                                placeholder="Enter Tags"
                                maxLength={17}
                              />
                            </div>
                          </div>
                          {!id && (
                            <div className="col-md-12 mt-2">
                              <div className="form-group mb-1">
                                <label className='genericlabel' style={{ fontSize: "14px", fontWeight: 700 }}>Product Image</label>
                                <span className="text-danger"> * </span>
                              </div>
                              <div className="p-2 border rounded" style={{ backgroundColor: "#F8FAFC", borderColor: "#E2E8F0", borderRadius: "10px" }}>
                                <ImageAdd productImageHandler={productImageHandler} productData={product} imageIndex={1} removeImageHandler={removeImageHandler} />
                              </div>
                            </div>
                          )}
                        </div>
                        {
                          (!id && manDatoryAttr?.length > 0) && <>
                            <div className={`mt-3 ${styles.whiteContainer}`}>
                              <div className="col-md-12">
                                <h3>Specification Details</h3>
                              </div>
                              {manDatoryAttr?.filter(item => Boolean(item?.is_mandatory ?? item?.is_mandate))?.map((item, index) => {
                                const attrName = item?.product_type_attribute || item?.mandatory_attribute || item?.attribute_name;
                                return <div className="col-md-4" key={item?.id || index}>
                                  <div className="form-group">
                                    <label className='genericlabel' style={{ textTransform: "capitalize" }}>{attrName}</label>
                                    <span className="text-danger" > * </span>
                                    <input type="text" className="form-control" id=""
                                      onKeyPress={preventMinus} name={`${attrName}`} value={manDatoryAttrValue?.[attrName] || ""}
                                      onChange={(e) => setmanDatoryAttrValue({ ...manDatoryAttrValue, [e.target.name]: e.target.value })}
                                      placeholder={`Enter ${attrName}`}
                                    />
                                  </div>
                                </div>
                              })
                              }
                              {manDatoryAttr?.filter(item => !Boolean(item?.is_mandatory ?? item?.is_mandate))?.map((item, index) => {
                                const attrName = item?.product_type_attribute || item?.mandatory_attribute || item?.attribute_name;
                                return <div className="col-md-4" key={item?.id || index}>
                                  <div className="form-group">
                                    <label className='genericlabel' style={{ textTransform: "capitalize" }}>{attrName}</label>
                                    <input type="text" className="form-control" id=""
                                      onKeyPress={preventMinus} name={`${attrName}`} value={manDatoryAttrValue?.[attrName] || ""}
                                      onChange={(e) => setmanDatoryAttrValue({ ...manDatoryAttrValue, [e.target.name]: e.target.value })}
                                      placeholder={`Enter ${attrName}`}
                                    />
                                  </div>
                                </div>
                              })
                              }
                            </div>
                          </>
                        }


                        <div className={`mt-3 ${styles.whiteContainer}`}>
                          <div className="col-md-12">
                            <h3>Product Manufacture Details</h3>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className='genericlabel'> Manufacturer Name </label>
                              <span className="text-danger" > * </span>
                              <input type="text" className="form-control"
                                id="" name="pc_manufacturer_or_packer_name"
                                value={product.pc_manufacturer_or_packer_name}
                                onChange={(e) => {
                                  let cleanedValue = e.target.value.replace(/[_+\-$%#@&^*(]/g, "");
                                  cleanedValue = cleanedValue.trimStart();
                                  cleanedValue = cleanedValue.replace(/^[^a-zA-Z]+/, "");
                                  setProduct({ ...product, [e.target.name]: cleanedValue });
                                  if (cleanedValue.trim()) {
                                    setProductErr((prev) => ({ ...prev, [e.target.name]: false }));
                                  }
                                }}
                                onKeyPress={(e) => {
                                  if (!product.pc_manufacturer_or_packer_name && /[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onBlur={(e) => errorHandler(e)}
                                placeholder="Enter Manufacturer Name"
                              />
                              {
                                productErr?.pc_manufacturer_or_packer_name === "invalid" ? (
                                  <span className="text-danger tiny_size" > Manufacturer Name cannot start with a number! </span>
                                ) : productErr?.pc_manufacturer_or_packer_name ? (
                                  <span className="text-danger tiny_size" > This field is required ! </span>
                                ) : null
                              }
                            </div>
                          </div>
                          <div className="col-md-4">
                            <div className="form-group">
                              <label className='genericlabel'> Manufacturer Address </label>
                              <span className="text-danger" > * </span>
                              <input type="text" className="form-control" id=""
                                name="pc_manufacturer_or_packer_address"
                                value={product.pc_manufacturer_or_packer_address}
                                onChange={(e) => {
                                  const cleanedValue = e.target.value.replace(/[^a-zA-Z0-9\s,.\-/]/g, "").trimStart();
                                  setProduct({ ...product, [e.target.name]: cleanedValue });
                                  if (cleanedValue.trim()) {
                                    setProductErr((prev) => ({ ...prev, [e.target.name]: false }));
                                  }
                                }}
                                onKeyPress={(e) => {
                                  if (!/[a-zA-Z0-9\s,.\-/#]/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onBlur={(e) => errorHandler(e)}
                                placeholder="Enter Manufacturer Address" />
                              {
                                productErr?.pc_manufacturer_or_packer_address === "invalid" ? (
                                  <span className="text-danger tiny_size" > Invalid characters are not allowed in Manufacturer Address! </span>
                                ) : productErr?.pc_manufacturer_or_packer_address ? (
                                  <span className="text-danger tiny_size" > This field is required ! </span>
                                ) : null
                              }
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label className='genericlabel'> Manufacturing Year</label>
                              <span className="text-danger" > * </span>
                              <input type="text" className="form-control" name="pc_month_year_of_manufacture_packing_import" value={product.pc_month_year_of_manufacture_packing_import} onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, "").slice(0, 4);
                                setProduct({ ...product, [e.target.name]: val });
                              }
                              }
                                onKeyDown={(e) => {
                                  if (!/[0-9]/.test(e.key) && !["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                onBlur={(e) => {
                                  const year = Number(e.target.value);
                                  const currentYear = new Date().getFullYear();
                                  if (e.target.value && (year < 1900 || year > currentYear)) {
                                    toast.error(`Please enter a valid year between 1900 and ${currentYear}!`);
                                  }
                                  errorHandler(e);
                                }}
                                placeholder="Enter Manufacturing Year (e.g. 2024)"
                                maxLength={4}
                              />
                              {
                                productErr?.pc_month_year_of_manufacture_packing_import ? (
                                  <span className="text-danger tiny_size" > This field is required ! </span>
                                ) : null
                              }
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label className='genericlabel'> Country Of Origin</label>
                              <span className="text-danger" > * </span>
                              <input
                                type="text"
                                className="form-control"
                                name="pc_imported_product_country_of_origin"
                                value={product.pc_imported_product_country_of_origin ?? "India"}
                                onChange={(e) => {
                                  const val = e.target.value.replace(/[^a-zA-Z\s]/g, "").trimStart();
                                  setProduct({
                                    ...product,
                                    pc_imported_product_country_of_origin: val
                                  });
                                }}
                                onBlur={(e) => {
                                  if (!product.pc_imported_product_country_of_origin || !product.pc_imported_product_country_of_origin.trim()) {
                                    setProduct({
                                      ...product,
                                      pc_imported_product_country_of_origin: "India"
                                    });
                                  }
                                  errorHandler(e);
                                }}
                                onKeyDown={(e) => {
                                  if (e.ctrlKey || e.metaKey) return;
                                  if (
                                    !/[a-zA-Z\s]/.test(e.key) &&
                                    !["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key)
                                  ) {
                                    e.preventDefault();
                                  }
                                }}
                                onPaste={(e) => {
                                  e.preventDefault();
                                  const pasted = e.clipboardData.getData("text").replace(/[^a-zA-Z\s]/g, "").trimStart();
                                  setProduct({
                                    ...product,
                                    pc_imported_product_country_of_origin: pasted
                                  });
                                }}
                                placeholder="Enter Product Country Of Origin"
                              />
                              {
                                productErr?.pc_imported_product_country_of_origin ? (
                                  <span className="text-danger tiny_size" > This field is required ! </span>
                                ) : null
                              }
                            </div>
                          </div>

                          <div className="col-md-4">
                            <div className="form-group">
                              <label className='genericlabel'>Common or Generic Name </label>
                              <span className="text-danger" > * </span>
                              <input
                                type="text"
                                className="form-control"
                                id=""
                                name="pc_common_or_generic_name_of_commodity"
                                value={product.pc_common_or_generic_name_of_commodity}
                                onChange={(e) => {
                                  let cleanedValue = e.target.value.replace(/[^a-zA-Z0-9\s]/g, "");
                                  cleanedValue = cleanedValue.trimStart();
                                  cleanedValue = cleanedValue.replace(/^[^a-zA-Z]+/, "");
                                  setProduct({ ...product, [e.target.name]: cleanedValue });
                                  if (cleanedValue.trim()) {
                                    setProductErr((prev) => ({ ...prev, [e.target.name]: false }));
                                  }
                                }}
                                onKeyPress={(e) => {
                                  if (!product.pc_common_or_generic_name_of_commodity && /[0-9]/.test(e.key)) {
                                    e.preventDefault();
                                  }
                                }}
                                placeholder="Enter Common or Generic Product Name"
                                onBlur={(e) => errorHandler(e)}
                              />
                              {
                                productErr?.pc_common_or_generic_name_of_commodity === "invalid" ? (
                                  <span className="text-danger tiny_size" > Common or Generic Name cannot start with a number! </span>
                                ) : productErr?.pc_common_or_generic_name_of_commodity ? (
                                  <span className="text-danger tiny_size" > This field is required ! </span>
                                ) : null
                              }
                            </div>
                          </div>
                          {/* {product.has_variations == false && <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'>HSN Number</label>
                                <span className="text-danger" > * </span>
                                <input type="text" className="form-control" readOnly={!!productId} name="hsn" value={product.hsn}
                                  onChange={(e) =>
                                    setProduct({ ...product, [e.target.name]: e.target.value })
                                  } onBlur={(e) => errorHandler(e)} placeholder="Enter HSN Number"
                                />
                                {
                                  productErr?.hsn ? (
                                    <span className="text-danger tiny_size" > This field is required ! </span>
                                  ) : null
                                }
                              </div>
                            </div>} */}
                        </div>

                        {id && (
                          <div className={`mt-3 ${styles.whiteContainer}`}>
                            <div className="col-md-12">
                              <h3><FaRupeeSign style={{ color: "#F97316", marginRight: "10px", fontSize: "17px" }} /> Tax Details</h3>
                            </div>

                            <div className="col-md-6 col-sm-12">
                              <div className="form-group">
                                <label className='genericlabel'>Tax / GST (%)</label>
                                <span className="text-danger"> * </span>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="tax"
                                  value={product.tax ?? ""}
                                  onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '+') e.preventDefault();
                                  }}
                                  onChange={(e) => {
                                    let val = e.target.value.replace(/[^0-9.]/g, "");

                                    const parts = val.split(".");
                                    if (parts.length > 2) {
                                      val = parts[0] + "." + parts.slice(1).join("");
                                    }

                                    if (val !== "" && Number(val) > 100) {
                                      val = "100";
                                    }

                                    setProduct({ ...product, tax: val });
                                  }}
                                  placeholder="Enter Tax Rate (e.g. 18)"
                                />
                              </div>
                            </div>

                            <div className="col-md-6 col-sm-12">
                              <div className="form-group">
                                <label className='genericlabel'>Tax Included</label>
                                <span className="text-danger"> * </span>

                                <select
                                  className="form-control"
                                  name="tax_included"
                                  value={product.tax_included !== undefined && product.tax_included !== null ? String(product.tax_included) : "true"}
                                  onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value === "true" })}
                                >
                                  <option value="true">Yes (Inclusive)</option>
                                  <option value="false">No (Exclusive)</option>
                                </select>
                              </div>
                            </div>
                          </div>
                        )}

                        {!id && (
                          <div className={`mt-3 ${styles.whiteContainer}`}>
                            <div className="col-md-12">
                              <h3>Shipping</h3>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'>Time To Ship </label>
                                <span className="text-danger" > * </span>
                                <select
                                  className="form-control"
                                  name="time_to_ship"
                                  value={product.time_to_ship}
                                  onChange={(e) =>
                                    setProduct({ ...product, [e.target.name]: e.target.value })
                                  }
                                  onBlur={(e) => errorHandler(e)}
                                >
                                  <option value="">Time to Ship</option>
                                  {timeToShipLength.map((item, index) => (
                                    <option value={`P${item}D`} key={index}>{item === 1 ? `${item}Day` : `${item} Days`}</option>
                                  ))}
                                </select>
                                {
                                  productErr?.time_to_ship ? (
                                    <span className="text-danger tiny_size" > This field is required ! </span>
                                  ) : null
                                }
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'>Product Returnable </label>
                                <span className="text-danger" > * </span>
                                <select className="form-control" name="returnable"
                                  value={product.returnable}
                                  onChange={(e) =>
                                    setProduct({ ...product, [e.target.name]: e.target.value })
                                  }
                                  onBlur={(e) => errorHandler(e)}>
                                  <option value={""}>Product Returnable</option>
                                  <option value={"true"}>Yes</option>
                                  <option value={"false"}>No</option>
                                </select>
                                {
                                  productErr?.returnable ? (
                                    <span className="text-danger tiny_size" > This field is required ! </span>
                                  ) : null
                                }
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'> Product Return Window </label>
                                <span className="text-danger" > * </span>
                                <select className="form-control" name="return_window" value={product.return_window}
                                  onChange={(e) =>
                                    setProduct({ ...product, [e.target.name]: e.target.value })
                                  }
                                  onBlur={(e) => errorHandler(e)}
                                >
                                  <option value="">Select Return Window</option>
                                  {returnWindowLength.map((item, index) => (
                                    <option value={`P${item}D`} key={index}>{item == 1 ? `${item}Day` : `${item}Days`}</option>
                                  ))}
                                </select>
                                {
                                  productErr?.return_window ? (
                                    <span className="text-danger tiny_size" > This field is required ! </span>
                                  ) : null
                                }
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'>Product Cancellable </label>
                                <span className="text-danger" > * </span>

                                <select className="form-control" name="cancelable" value={product.cancelable}
                                  onChange={(e) =>
                                    setProduct({ ...product, [e.target.name]: e.target.value })
                                  } onBlur={(e) => errorHandler(e)}  >
                                  <option value={""}>Select Cancellable</option>
                                  <option value={"true"}>Yes</option>
                                  <option value={"false"}>No</option>
                                </select>
                                {
                                  productErr?.cancelable ? (
                                    <span className="text-danger tiny_size" > This field is required ! </span>
                                  ) : null
                                }
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'> Return Pickup Available </label>
                                <span className="text-danger" > * </span>

                                <select className="form-control" name="seller_pickup_return" value={product.seller_pickup_return}
                                  onChange={(e) =>
                                    setProduct({ ...product, [e.target.name]: e.target.value })
                                  } onBlur={(e) => errorHandler(e)}             >
                                  <option value={""}>Select Return Pickup Available</option>
                                  <option value={"true"}>Yes</option>
                                  <option value={"false"}>No</option>
                                </select>
                                {
                                  productErr?.seller_pickup_return ? (
                                    <span className="text-danger tiny_size" > This field is required ! </span>
                                  ) : null
                                }
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'> Product Replaceable </label>
                                <span className="text-danger" > * </span>

                                <select className="form-control" name="replaceable" value={product.replaceable}
                                  onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value })} onBlur={(e) => errorHandler(e)}>
                                  <option value={""}>Select Product Replaceable</option>
                                  <option value={"true"}>Yes</option>
                                  <option value={"false"}>No</option>
                                </select>
                                {
                                  productErr?.replaceable ? (
                                    <span className="text-danger tiny_size" > This field is required ! </span>
                                  ) : null
                                }
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'> Minimum Quantity </label>
                                <span className="text-danger" > * </span>
                                <input
                                  type="number"
                                  className={`form-control ${productErr?.min_quantity ||
                                    (product.min_quantity !== undefined && product.min_quantity !== "" && Number(product.min_quantity) <= 0)
                                    ? "is-invalid border-danger" : ""
                                    }`}
                                  name="min_quantity"
                                  min={1}
                                  value={product.min_quantity}
                                  onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '+') e.preventDefault();
                                  }}
                                  onWheel={(e) => e.target.blur()}
                                  onBlur={(e) => errorHandler(e)}
                                  onChange={(e) => {
                                    let val = e.target.value;
                                    if (val.length > 10) {
                                      val = val.slice(0, 10);
                                    }
                                    if (val === "" || Number(val) >= 0) {
                                      setProduct({ ...product, [e.target.name]: val });
                                      if (val) {
                                        setProductErr((prev) => ({ ...prev, [e.target.name]: false }));
                                      }
                                    }
                                  }}
                                  placeholder="Enter Minimum Quantity"
                                />
                                {productErr?.min_quantity && (
                                  <span className="text-danger tiny_size">This field is required !</span>
                                )}
                                {product.min_quantity !== undefined && product.min_quantity !== "" && Number(product.min_quantity) <= 0 && (
                                  <span className="text-danger tiny_size">Minimum Quantity cannot be 0 or less!</span>
                                )}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'> Maximum Quantity </label>
                                <span className="text-danger" > * </span>
                                <input
                                  type="number"
                                  className={`form-control ${productErr?.max_quantity ||
                                    (product.max_quantity !== undefined && product.max_quantity !== "" && Number(product.max_quantity) <= 0) ||
                                    (product.min_quantity !== "" && Number(product.min_quantity) > 0 && product.max_quantity !== "" && Number(product.max_quantity) > 0 && Number(product.min_quantity) > Number(product.max_quantity))
                                    ? "is-invalid border-danger" : ""
                                    }`}
                                  onWheel={(e) => e.target.blur()}
                                  onBlur={(e) => errorHandler(e)}
                                  name="max_quantity"
                                  min={1}
                                  value={product.max_quantity}
                                  onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '+') e.preventDefault();
                                  }}
                                  onChange={(e) => {
                                    let val = e.target.value;
                                    if (val.length > 10) {
                                      val = val.slice(0, 10);
                                    }
                                    if (val === "" || Number(val) >= 0) {
                                      setProduct({ ...product, [e.target.name]: val });
                                      if (val) {
                                        setProductErr((prev) => ({ ...prev, [e.target.name]: false }));
                                      }
                                    }
                                  }}
                                  placeholder="Enter Maximum Quantity"
                                />
                                {productErr?.max_quantity && (
                                  <span className="text-danger tiny_size">This field is required !</span>
                                )}
                                {product.max_quantity !== undefined && product.max_quantity !== "" && Number(product.max_quantity) <= 0 ? (
                                  <span className="text-danger tiny_size">Maximum Quantity cannot be 0 or negative!</span>
                                ) : (product.min_quantity !== "" && Number(product.min_quantity) > 0 && product.max_quantity !== "" && Number(product.max_quantity) > 0 && Number(product.min_quantity) > Number(product.max_quantity)) ? (
                                  <span className="text-danger tiny_size">
                                    Maximum Quantity must be greater than or equal to Minimum Quantity ({product.min_quantity})!
                                  </span>
                                ) : null}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'> Time To Deliver </label>
                                <span className="text-danger" > * </span>
                                <select
                                  className={`form-control ${productErr?.time_to_deliver ? "is-invalid border-danger" : ""}`}
                                  name="time_to_deliver"
                                  value={product.time_to_deliver}
                                  onBlur={(e) => errorHandler(e)}
                                  onChange={(e) => {
                                    setProduct({ ...product, [e.target.name]: e.target.value });
                                    if (e.target.value) {
                                      setProductErr((prev) => ({ ...prev, [e.target.name]: false }));
                                    }
                                  }}
                                >
                                  <option value="">Select Time To Deliver</option>
                                  <option value="P1D">1 Day (P1D)</option>
                                  <option value="P2D">2 Days (P2D)</option>
                                  <option value="P3D">3 Days (P3D)</option>
                                  <option value="P5D">5 Days (P5D)</option>
                                  <option value="P7D">7 Days (P7D)</option>
                                </select>
                                {productErr?.time_to_deliver ? (
                                  <span className="text-danger tiny_size" > This field is required ! </span>
                                ) : null}
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'> COD Allowed </label>
                                <span className="text-danger" > * </span>
                                <select
                                  className={`form-control ${productErr?.cod_allowed ? "is-invalid border-danger" : ""}`}
                                  name="cod_allowed"
                                  value={product.cod_allowed !== undefined && product.cod_allowed !== null && product.cod_allowed !== "" ? String(product.cod_allowed) : ""}
                                  onBlur={(e) => errorHandler(e)}
                                  onChange={(e) => {
                                    const val = e.target.value;
                                    setProduct({
                                      ...product,
                                      [e.target.name]: val === "" ? "" : val === "true"
                                    });
                                    if (val !== "") {
                                      setProductErr((prev) => ({ ...prev, [e.target.name]: false }));
                                    }
                                  }}
                                >
                                  <option value="">Select COD Allowed</option>
                                  <option value="true">Yes</option>
                                  <option value="false">No</option>
                                </select>
                                {productErr?.cod_allowed ? (
                                  <span className="text-danger tiny_size" > This field is required ! </span>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                      {!id && (
                        <div className={styles.rightpart}>
                          <div className={` ${styles.whiteContainer} pb-3`}>
                            <div className="col-md-12 d-flex align-items-center mb-1 justify-content-between" >
                              <h3><FaRupeeSign style={{ color: "#F97316", marginRight: "10px", fontSize: "17px" }} /> Pricing & Tax</h3>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label className='genericlabel'>MRP</label>
                                <span className="text-danger"> * </span>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="base_price"
                                  maxLength={10}
                                  value={product.base_price || product.maximum_price || ""}
                                  onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '+') e.preventDefault();
                                  }}
                                  onWheel={(e) => e.target.blur()}

                                  onChange={(e) => {
                                    let val = e.target.value.replace(/[^0-9.]/g, "");

                                    const parts = val.split(".");
                                    if (parts.length > 2) {
                                      val = parts[0] + "." + parts.slice(1).join("");
                                    }

                                    const digitsOnly = val.replace(".", "");
                                    if (digitsOnly.length > 8) {
                                      return;
                                    }

                                    setProduct({
                                      ...product,
                                      base_price: val,
                                      maximum_price: val
                                    });
                                  }}
                                  placeholder="Enter Base Price / MRP"
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label className='genericlabel'>Selling Price</label>
                                <span className="text-danger"> * </span>
                                {(() => {
                                  const baseVal = Number(product.base_price || product.maximum_price || 0);
                                  const sellVal = Number(product.selling_price || product.current_price || 0);
                                  const isGreater = sellVal > baseVal && baseVal > 0;
                                  return (
                                    <>
                                      <input
                                        type="number"
                                        className={`form-control ${isGreater ? "is-invalid border-danger" : ""}`}
                                        name="selling_price"
                                        value={product.selling_price || product.current_price || ""}
                                        onWheel={(e) => e.target.blur()}
                                        onChange={(e) => {
                                          let val = e.target.value.replace(/[^0-9.]/g, "");

                                          const parts = val.split(".");
                                          if (parts.length > 2) {
                                            val = parts[0] + "." + parts.slice(1).join("");
                                          }

                                          const digitsOnly = val.replace(".", "");
                                          if (digitsOnly.length > 8) {
                                            return;
                                          }

                                          setProduct({
                                            ...product,
                                            selling_price: val,
                                            current_price: val
                                          });
                                        }}
                                        placeholder="Enter Current / Selling Price"
                                      />
                                      {isGreater && (
                                        <span className="text-danger tiny_size">Selling price cannot be greater than MRP price!</span>
                                      )}
                                    </>
                                  );
                                })()}
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label className='genericlabel'>Tax / GST (%)</label>
                                <span className="text-danger"> * </span>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="tax"
                                  value={product.tax}
                                  onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '+') e.preventDefault();
                                  }}
                                  onChange={(e) => {
                                    let val = e.target.value.replace(/[^0-9.]/g, "");

                                    const parts = val.split(".");
                                    if (parts.length > 2) {
                                      val = parts[0] + "." + parts.slice(1).join("");
                                    }

                                    if (val !== "" && Number(val) > 100) {
                                      val = "100";
                                    }

                                    setProduct({ ...product, tax: val });
                                  }}
                                  placeholder="Enter Tax Rate (e.g. 18)"
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label className='genericlabel'>Tax Included</label>
                                <span className="text-danger"> * </span>

                                <select
                                  className="form-control"
                                  name="tax_included"
                                  value={product.tax_included !== undefined ? String(product.tax_included) : "true"}
                                  onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value === "true" })}
                                >
                                  <option value="true">Yes (Inclusive)</option>
                                  <option value="false">No (Exclusive)</option>
                                </select>
                              </div>
                            </div>
                          </div>

                          <div className={`mt-3 ${styles.whiteContainer}`}>
                            <div className="col-md-12">
                              <h3><FiLayers style={{ color: "#F97316", marginRight: "10px", fontSize: "19px" }} /> Other Product Details</h3>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label className='genericlabel'>SKU Code</label>
                                <span className="text-danger"> * </span>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="sku"
                                  value={product.sku || ""}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(/[^a-zA-Z0-9\-_]/g, "").trimStart();
                                    setProduct({ ...product, sku: val });
                                  }}
                                  placeholder="Enter SKU Code (e.g. FNP-RRB-001)"
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label className='genericlabel'>HSN Code</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  name="hsn"
                                  maxLength={8}
                                  value={product.hsn || ""}
                                  onChange={(e) => {
                                    const val = e.target.value.replace(/[^0-9]/g, "").trimStart();
                                    setProduct({ ...product, hsn: val });
                                  }}
                                  onKeyDown={(e) => {
                                    if (e.ctrlKey || e.metaKey) return;
                                    const blockedKeys = ["-", "+", "e", "E", ".", " "];
                                    if (
                                      blockedKeys.includes(e.key) ||
                                      (!/[0-9]/.test(e.key) &&
                                        !["Backspace", "Delete", "Tab", "ArrowLeft", "ArrowRight"].includes(e.key))
                                    ) {
                                      e.preventDefault();
                                    }
                                  }}
                                  placeholder="Enter HSN Code (e.g. 06031100)"
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label className='genericlabel'>Unit Of Measurement</label>
                                <span className="text-danger" > * </span>
                                <select name="uom" id="" className='form-control' value={product.uom}
                                  onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value, })} onBlur={(e) => errorHandler(e)}  >
                                  <option value="" disabled selected>Select UOM</option>
                                  <option value="dozen">Dozen</option>
                                  <option value="gram">Gram</option>
                                  <option value="kilogram">Kilogram</option>
                                  <option value="tonne">Ton</option>
                                  <option value="litre">Litre</option>
                                  <option value="mililitre">Millilitre</option>
                                  <option value="unit">Unit</option>
                                </select>
                                {
                                  productErr?.uom ? (
                                    <span className="text-danger tiny_size" > This field is required ! </span>
                                  ) : null
                                }
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label className='genericlabel'>UOM Value</label>
                                <span className="text-danger"> * </span>
                                <input
                                  type="number"
                                  className="form-control"
                                  name="uom_value"
                                  // min="0"
                                  maxLength={8}
                                  onWheel={(e) => e.target.blur()}
                                  onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                  value={product.uom_value || ""}
                                  onChange={(e) => {
                                    let val = e.target.value;
                                    if (val.replace(".", "").length > 5) return;
                                    if (val === "" || Number(val) >= 0) {
                                      setProduct({ ...product, uom_value: val });
                                    }
                                  }}
                                  placeholder="Enter UOM Value (e.g. 1 or 4)"
                                />
                              </div>
                            </div>

                            <div className="col-md-6">
                              <div className="form-group">
                                <label className='genericlabel'>FSSAI License Number</label>
                                <input type="text" className="form-control" id="" onKeyPress={preventMinus} name="pf_brand_owner_FSSAI_license_no"
                                  value={product.pf_brand_owner_FSSAI_license_no}
                                  onChange={(e) => setProduct({ ...product, [e.target.name]: e.target.value })} placeholder="Enter FSSAI License Number"
                                  onBlur={(e) => errorHandler(e)}
                                  maxLength={14}
                                />
                              </div>
                            </div>

                            <div className="col-md-12 mt-2">
                              <h3><FiGrid style={{ color: "#F97316", marginRight: "10px", fontSize: "19px" }} /> Set, Case & Selling Unit</h3>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'>Set</label>
                                <input
                                  type="number"
                                  min="0"
                                  step="1"
                                  className="form-control"
                                  name="set"
                                  value={product.set ?? ""}
                                  onWheel={(e) => e.target.blur()}

                                  onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '+') e.preventDefault();
                                  }}
                                  onChange={(e) => {
                                    let val = e.target.value.replace(/[^0-9]/g, "");
                                    if (val.length > 5) {
                                      val = val.slice(0, 5);
                                    }
                                    setProduct({ ...product, set: val, pack_config_set: val });
                                  }}
                                  placeholder="Enter Set (e.g. 1)"
                                />
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'>Case</label>
                                <input
                                  type="number"
                                  min="0"
                                  step="1"
                                  className="form-control"
                                  onWheel={(e) => e.target.blur()}
                                  name="case"
                                  value={product.case ?? ""}
                                  onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '+') e.preventDefault();
                                  }}
                                  onChange={(e) => {
                                    let val = e.target.value.replace(/[^0-9]/g, "");
                                    if (val.length > 5) {
                                      val = val.slice(0, 5);
                                    }
                                    setProduct({ ...product, case: val });
                                  }}
                                  placeholder="Enter Case (e.g. 1)"
                                />
                              </div>
                            </div>

                            <div className="col-md-4">
                              <div className="form-group">
                                <label className='genericlabel'>Selling Unit</label>
                                <input
                                  type="number"
                                  min="0"
                                  step="1"
                                  className="form-control"
                                  onWheel={(e) => e.target.blur()}

                                  name="selling_unit"
                                  value={product.selling_unit ?? ""}
                                  onKeyDown={(e) => {
                                    if (e.key === '-' || e.key === 'e' || e.key === '+') e.preventDefault();
                                  }}
                                  onChange={(e) => {
                                    let val = e.target.value.replace(/[^0-9]/g, "");
                                    if (val.length > 5) {
                                      val = val.slice(0, 5);
                                    }
                                    setProduct({ ...product, selling_unit: val });
                                  }}
                                  placeholder="Enter Selling Unit (e.g. 1)"
                                />
                              </div>
                            </div>

                            {/* Pack & Packaging Dimensions Card */}
                            <div className="col-12 mt-3 px-0">
                              <div className="p-3 mb-2" style={{ backgroundColor: "#ffffff", borderRadius: "12px", border: "1px solid #E2E8F0", boxShadow: "0 2px 6px rgba(15, 23, 42, 0.03)" }}>
                                <div className="d-flex align-items-center mb-3" style={{ gap: "8px" }}>
                                  <FiPackage style={{ color: "#F97316", fontSize: "16px" }} />
                                  <span style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A" }}>Pack & Packaging Dimensions</span>
                                </div>
                                <div className="row">
                                  <div className="col-md-4 mb-2">
                                    <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Height (cm)</label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-sm"
                                      style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                                      value={product.packing_height ?? ""}
                                      onWheel={(e) => e.target.blur()}
                                      onChange={(e) => {
                                        let value = e.target.value.trimStart().replace(/[^0-9.]/g, "");
                                        const parts = value.split(".");
                                        if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                                        if (value.replace(".", "").length > 4) return;
                                        setProduct({ ...product, packing_height: value });
                                      }}
                                      onKeyDown={(e) => {
                                        if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onPaste={(e) => {
                                        const pastedText = e.clipboardData.getData("text");
                                        if (!/^\d*\.?\d*$/.test(pastedText)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      placeholder="Height"
                                    />
                                  </div>

                                  <div className="col-md-4 mb-2">
                                    <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Length (cm)</label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-sm"
                                      style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                                      value={product.packing_length ?? ""}
                                      onWheel={(e) => e.target.blur()}
                                      onChange={(e) => {
                                        let value = e.target.value.trimStart().replace(/[^0-9.]/g, "");
                                        const parts = value.split(".");
                                        if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                                        if (value.replace(".", "").length > 4) return;
                                        setProduct({ ...product, packing_length: value });
                                      }}
                                      onKeyDown={(e) => {
                                        if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onPaste={(e) => {
                                        const pastedText = e.clipboardData.getData("text");
                                        if (!/^\d*\.?\d*$/.test(pastedText)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      placeholder="Length"
                                    />
                                  </div>

                                  <div className="col-md-4 mb-2">
                                    <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Breadth (cm)</label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-sm"
                                      style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                                      value={product.packing_breadth ?? ""}
                                      onWheel={(e) => e.target.blur()}
                                      onChange={(e) => {
                                        let value = e.target.value.trimStart().replace(/[^0-9.]/g, "");
                                        const parts = value.split(".");
                                        if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                                        if (value.replace(".", "").length > 4) return;
                                        setProduct({ ...product, packing_breadth: value });
                                      }}
                                      onKeyDown={(e) => {
                                        if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onPaste={(e) => {
                                        const pastedText = e.clipboardData.getData("text");
                                        if (!/^\d*\.?\d*$/.test(pastedText)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      placeholder="Breadth"
                                    />
                                  </div>

                                  <div className="col-md-6 mb-2">
                                    <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Packaging Weight (kg)</label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-sm"
                                      style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                                      value={product.packing_weight ?? ""}
                                      onWheel={(e) => e.target.blur()}
                                      onChange={(e) => {
                                        let value = e.target.value.trimStart().replace(/[^0-9.]/g, "");
                                        const parts = value.split(".");
                                        if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                                        if (value.replace(".", "").length > 4) return;
                                        setProduct({ ...product, packing_weight: value, weights: value });
                                      }}
                                      onKeyDown={(e) => {
                                        if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onPaste={(e) => {
                                        const pastedText = e.clipboardData.getData("text");
                                        if (!/^\d*\.?\d*$/.test(pastedText)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      placeholder="Packaging Weight"
                                    />
                                  </div>

                                  <div className="col-md-6 mb-2">
                                    <label className="form-label font-weight-bold" style={{ fontSize: "12px", color: "#334155" }}>Packing Price (₹)</label>
                                    <input
                                      type="number"
                                      step="any"
                                      className="form-control form-control-sm"
                                      style={{ borderRadius: "8px", height: "36px", fontSize: "13px" }}
                                      value={product.packing_price ?? ""}
                                      onWheel={(e) => e.target.blur()}
                                      onChange={(e) => {
                                        let value = e.target.value.trimStart().replace(/[^0-9.]/g, "");
                                        if (value.replace(".", "").length > 4) return;
                                        const parts = value.split(".");
                                        if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                                        setProduct({ ...product, packing_price: value });
                                      }}
                                      onKeyDown={(e) => {
                                        if (["-", "+", "e", "E", "@", "#", "!", "$", "%", "*", "(", ")", "^", "&"].includes(e.key)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      onPaste={(e) => {
                                        const pastedText = e.clipboardData.getData("text");
                                        if (!/^\d*\.?\d*$/.test(pastedText)) {
                                          e.preventDefault();
                                        }
                                      }}
                                      placeholder="Price (defaults to MRP)"
                                    />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className={`mt-3 ${styles.whiteContainer}`}>
                            <div className="col-12 mb-2 px-0">
                              <h3><FiBox style={{ color: "#F97316", marginRight: "10px", fontSize: "19px" }} /> Inventory & Warehouse <span className="text-danger">*</span></h3>
                            </div>

                            <div className="row mx-0 w-100 align-items-end">
                              <div className="col-12 px-0 mb-2">
                                <div className="form-group mb-0">
                                  <label className="genericlabel mb-1" style={{ fontSize: "12px", fontWeight: 600 }}>
                                    Select Warehouse to Add <span className="text-danger">*</span>
                                  </label>
                                  <Select
                                    allowClear
                                    disabled={Object.keys(selectedWarehouses).some((id) => selectedWarehouses[id])}
                                    style={{ width: "100%", minHeight: "38px" }}
                                    placeholder={Object.keys(selectedWarehouses).some((id) => selectedWarehouses[id]) ? "Warehouse already selected" : "Select Warehouse..."}
                                    value={tempSelectedWarehouses?.[0] || undefined}
                                    optionFilterProp="children"
                                    filterOption={(input, option) =>
                                      (option?.children ?? "").toLowerCase().includes(input.toLowerCase())
                                    }
                                    onChange={(value) => {
                                      setTempSelectedWarehouses(value ? [value] : []);
                                    }}
                                  >
                                    {data?.filter((wh) => wh?.status === true || wh?.status === 1 || wh?.status === "true")?.map((wh, idx) => {
                                      const isAdded = selectedWarehouses[String(wh.id)] || selectedWarehouses[wh.id];
                                      return (
                                        <Select.Option key={wh.id || idx} value={String(wh.id)}>
                                          {wh.warehouse_name || `Warehouse ${wh.id}`}{isAdded ? " (Added)" : ""}
                                        </Select.Option>
                                      );
                                    })}
                                  </Select>
                                </div>
                              </div>

                              <div className="col-7 pl-0 pr-1 mb-2">
                                <div className="form-group mb-0">
                                  <label className="genericlabel mb-1" style={{ fontSize: "12px", fontWeight: 600 }}>
                                    Available Quantity
                                  </label>
                                  <input
                                    type="number"
                                    min="0"
                                    disabled={Object.keys(selectedWarehouses).some((id) => selectedWarehouses[id])}
                                    className="form-control"
                                    style={{ height: "38px", borderRadius: "6px", fontSize: "13px" }}
                                    placeholder="Quantity (e.g. 10)"
                                    onWheel={(e) => e.target.blur()}
                                    value={tempWarehouseQty}
                                    onChange={(e) => {
                                      const val = e.target.value;
                                      if (val === "" || Number(val) >= 0) {
                                        if (val.length > 6) return;
                                        setTempWarehouseQty(val);
                                      }
                                    }}
                                    onKeyDown={(e) => {
                                      if (["e", "E", "+", "-"].includes(e.key)) {
                                        e.preventDefault();
                                      }
                                      if (e.key === "Enter" && tempSelectedWarehouses.length > 0 && !Object.keys(selectedWarehouses).some((id) => selectedWarehouses[id])) {
                                        e.preventDefault();
                                        const newSelected = { ...selectedWarehouses };
                                        const newQty = { ...warehouseQty };
                                        tempSelectedWarehouses.forEach(whId => {
                                          const idStr = String(whId);
                                          newSelected[idStr] = true;
                                          newQty[idStr] = tempWarehouseQty !== "" ? tempWarehouseQty : (newQty[idStr] || "0");
                                        });
                                        setSelectedWarehouses(newSelected);
                                        setWarehouseQty(newQty);
                                        setTempSelectedWarehouses([]);
                                        setTempWarehouseQty("");
                                      }
                                    }}
                                  />
                                </div>
                              </div>

                              <div className="col-5 pl-1 pr-0 mb-2">
                                <div className="form-group mb-0">
                                  <button
                                    type="button"
                                    className="btn btn-primary w-100"
                                    style={{
                                      height: "38px",
                                      fontWeight: 600,
                                      borderRadius: "6px",
                                      fontSize: "12px",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      gap: "5px",
                                      whiteSpace: "nowrap",
                                      padding: "0 4px"
                                    }}
                                    disabled={Object.keys(selectedWarehouses).some((id) => selectedWarehouses[id]) || tempSelectedWarehouses.length === 0}
                                    onClick={() => {
                                      if (tempSelectedWarehouses.length === 0 || Object.keys(selectedWarehouses).some((id) => selectedWarehouses[id])) return;
                                      const newSelected = { ...selectedWarehouses };
                                      const newQty = { ...warehouseQty };
                                      tempSelectedWarehouses.forEach(whId => {
                                        const idStr = String(whId);
                                        newSelected[idStr] = true;
                                        newQty[idStr] = tempWarehouseQty !== "" ? tempWarehouseQty : (newQty[idStr] || "0");
                                      });
                                      setSelectedWarehouses(newSelected);
                                      setWarehouseQty(newQty);
                                      setTempSelectedWarehouses([]);
                                      setTempWarehouseQty("");
                                    }}
                                  >
                                    <i className="fas fa-plus-circle"></i> Add to Table
                                  </button>
                                </div>
                              </div>

                              {/* ---------------- Selected Warehouses Table ---------------- */}
                              {Object.keys(selectedWarehouses).some(id => selectedWarehouses[id]) ? (
                                <div className="col-12 px-0 mt-2">
                                  <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap" style={{ gap: "4px" }}>
                                    <span style={{ fontSize: "12.5px", fontWeight: 700, color: "#1E293B" }}>
                                      Selected Warehouses ({Object.keys(selectedWarehouses).filter(id => selectedWarehouses[id]).length})
                                    </span>
                                    <span style={{ fontSize: "11px", color: "#64748B" }}>
                                      Edit qty per warehouse
                                    </span>
                                  </div>
                                  <div style={{ borderRadius: "8px", border: "1px solid #E2E8F0", backgroundColor: "#ffffff", width: "100%" }}>
                                    <table className="table table-sm table-bordered table-hover mb-0" style={{ fontSize: "12px", width: "100%", tableLayout: "auto" }}>
                                      <thead style={{ backgroundColor: "#F8FAFC", color: "#334155" }}>
                                        <tr>
                                          <th style={{ width: "26px", textAlign: "center", padding: "6px 2px" }}>#</th>
                                          <th style={{ padding: "6px 8px" }}>Warehouse</th>
                                          <th style={{ width: "75px", textAlign: "center", padding: "6px 4px" }}>Qty</th>
                                          <th style={{ width: "34px", textAlign: "center", padding: "6px 2px" }}>Del</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {Object.keys(selectedWarehouses)
                                          .filter(whId => selectedWarehouses[whId])
                                          .map((whId, idx) => {
                                            const matchedWh = data?.find(w => String(w.id) === String(whId));
                                            const currentQty = warehouseQty[whId] !== undefined && warehouseQty[whId] !== ""
                                              ? warehouseQty[whId]
                                              : (sameQty || "");

                                            return (
                                              <tr key={whId}>
                                                <td style={{ textAlign: "center", verticalAlign: "middle", fontWeight: 600, color: "#64748B", padding: "6px 2px" }}>
                                                  {idx + 1}
                                                </td>
                                                <td style={{ verticalAlign: "middle", padding: "6px 8px" }}>
                                                  <div style={{ fontWeight: 600, color: "#0F172A", fontSize: "12px", lineHeight: "1.3" }}>
                                                    {matchedWh?.warehouse_name || `Warehouse #${whId}`}
                                                  </div>
                                                  <div style={{ fontSize: "10.5px", color: "#64748B", marginTop: "1px" }}>
                                                    ID: #{whId}{matchedWh?.warehouse_code ? ` | ${matchedWh.warehouse_code}` : ""}
                                                  </div>
                                                </td>
                                                <td style={{ verticalAlign: "middle", textAlign: "center", padding: "4px" }}>
                                                  <input
                                                    type="number"
                                                    min="0"
                                                    className="form-control form-control-sm text-center px-1"
                                                    style={{ borderRadius: "5px", height: "30px", fontSize: "12px" }}
                                                    placeholder="Qty"
                                                    value={currentQty}
                                                    onWheel={(e) => e.target.blur()}
                                                    onKeyDown={(e) => ["e", "E", "+", "-"].includes(e.key) && e.preventDefault()}
                                                    onChange={(e) => {
                                                      const val = e.target.value;
                                                      if (val === "" || Number(val) >= 0) {
                                                        setWarehouseQty(prev => ({ ...prev, [whId]: val }));
                                                      }
                                                    }}
                                                  />
                                                </td>
                                                <td style={{ textAlign: "center", verticalAlign: "middle", padding: "4px" }}>
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm btn-outline-danger p-0"
                                                    style={{ borderRadius: "4px", width: "26px", height: "26px", display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "11px" }}
                                                    title="Remove warehouse"
                                                    onClick={() => {
                                                      setSelectedWarehouses(prev => {
                                                        const updated = { ...prev };
                                                        delete updated[whId];
                                                        return updated;
                                                      });
                                                      setWarehouseQty(prev => {
                                                        const updated = { ...prev };
                                                        delete updated[whId];
                                                        return updated;
                                                      });
                                                    }}
                                                  >
                                                    <i className="fas fa-trash-alt"></i>
                                                  </button>
                                                </td>
                                              </tr>
                                            );
                                          })}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              ) : (
                                <div className="col-12 px-0 mt-2">
                                  <div className="p-3 text-center" style={{ backgroundColor: "#F8FAFC", borderRadius: "8px", border: "1px dashed #CBD5E1", color: "#64748B", fontSize: "12px" }}>
                                    <FiBox style={{ fontSize: "18px", marginBottom: "3px", color: "#94A3B8" }} />
                                    <div>No warehouse selected. Select above and click Add.</div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>

                    <div className="col-md-12 d-flex justify-content-end my-3">
                      <div className="d-flex" style={{ gap: "12px" }}>
                        {parseInt(product?.category_id) === 229 && <button
                          className="btn btn-primary btn-create-product"
                          onClick={() => setShowModal(true)}
                        >
                          Add Customisation
                        </button>}
                        <AntModal title={<span className="font-weight-bold text-primary">Add Customisation</span>}
                          open={showModal} onCancel={handleModelClose}
                          footer={[
                            <button key="close" className="btn btn-light btn-sm w-25" onClick={() => setShowModal(false)}>
                              Close
                            </button>,
                          ]} width={1200} centered>
                          {renderTree(treeData)}
                        </AntModal>
                        {!id ? (
                          <button
                            className="btn d-flex align-items-center justify-content-center shadow-sm text-white"
                            disabled={isLoading}
                            onClick={(e) => handleInput(e, "create")}
                            style={{
                              gap: "8px",
                              minWidth: "170px",
                              height: "44px",
                              borderRadius: "10px",
                              background: "linear-gradient(135deg, #F97316 0%, #EA580C 100%)",
                              border: "none",
                              fontWeight: 700,
                              fontSize: "14px",
                              boxShadow: "0 6px 20px rgba(249, 115, 22, 0.3)"
                            }}
                          >
                            {isLoading ? (
                              <>
                                <Spin size="small" />
                                <span>Creating...</span>
                              </>
                            ) : (
                              <>
                                <FiCheckCircle size={16} />
                                <span>Create Product</span>
                              </>
                            )}
                          </button>
                        ) : (
                          <button
                            className="btn d-flex align-items-center justify-content-center shadow-sm text-white"
                            disabled={isLoading}
                            onClick={(e) => handleInput(e, "update")}
                            style={{
                              gap: "8px",
                              minWidth: "170px",
                              height: "44px",
                              borderRadius: "10px",
                              background: "linear-gradient(135deg, #105293 0%, #0E4275 100%)",
                              border: "none",
                              fontWeight: 700,
                              fontSize: "14px",
                              boxShadow: "0 6px 20px rgba(16, 82, 147, 0.3)"
                            }}
                          >
                            {isLoading ? (
                              <>
                                <Spin size="small" />
                                <span>Updating...</span>
                              </>
                            ) : (
                              <>
                                <FiCheckCircle size={16} />
                                <span>Update Product</span>
                              </>
                            )}
                          </button>
                        )}
                      </div>
                    </div>

                    {/* <div className='col-md-12 d-flex justify-content-end'>
                        <div className="m-2">
                          {id === undefined ? <button className="btn btn-primary" onClick={(e) => { handleInput(e, "create") }}>
                            Create Product
                          </button> : <button className="btn btn-success" onClick={(e) => { handleInput(e, "update") }}>
                            Update
                          </button>}
                        </div>
                      </div> */}

                    <Modal
                      open={mopen}
                      // onClose={handleClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >

                      <Box sx={smstyle} className="variantBox">
                        <CloseIcon style={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer" }} onClick={handleClose} />
                        <p className="text-center" style={{ fontSize: "20px", fontWeight: "700" }}>Variants</p>


                        <div >
                          <Variants submitFun={submitFun} productIdVariantsData={productIdVariantsData} hasVariants={hasVariants} product={product} upDateVariantsHandler={upDateVariantsHandler} productTypeNmae={productTypeName} id={id} manDatoryAttr={manDatoryAttr} handleOpen={handleOpen} handleClose={handleClose} deletHandlerWhileCreate={deletHandlerWhileCreate} />
                        </div>
                      </Box>
                    </Modal>

                    <Modal
                      open={iopen}
                      // onClose={handleClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >

                      <div className={`variantBox ${styles.imageContainer}`}>
                        <div className="d-flex align-items-center justify-content-between mt-2">
                          <CloseIcon style={{ position: "absolute", top: "5px", right: "10px", cursor: "pointer" }} onClick={handleimageClose} />
                          <p className="" style={{ fontSize: "20px", fontWeight: "700" }}> Images</p>
                        </div>


                        <div>
                          <ImageAdd productImageHandler={productImageHandler} productData={product} imageIndex={1} removeImageHandler={removeImageHandler} />
                        </div>
                      </div>
                    </Modal>

                    <Modal
                      open={featureopen}
                      // onClose={handleClose}
                      aria-labelledby="modal-modal-title"
                      aria-describedby="modal-modal-description"
                    >

                      <Box sx={{ ...smstyle, minHeight: "300px" }} className="variantBox">
                        <CloseIcon style={{ position: "absolute", top: "5px", right: "10px", cursor: "pointer" }} onClick={handleFeaturesClose} />
                        <p className="" style={{ fontSize: "20px", fontWeight: "700" }}> Add Product Features</p>

                        <hr classNameName="sidebar-divider" />
                        <div className='p-3' style={{ height: "300px", overflow: "scroll" }}>
                          {
                            optionValues.map((item, index) => {

                              return <div className='mt-2' key={index}>

                                <div style={{ display: "flex", gap: "20px", alignItems: "center" }}>
                                  <span style={{ cursor: "pointer", color: "#fd4545" }}
                                    onClick={() => {
                                      let c = [...featureKeyValue];
                                      c.splice(index, 1);
                                      setfeatureKeyValue([...c]);
                                      setoptionValues((prev) => {
                                        let v = [...prev];
                                        v.splice(index, 1);
                                        return v
                                      })
                                    }}> <DeleteIcon />  </span>

                                  <div className='d-flex' style={{ gap: "20px" }}>
                                    <input type="text" placeholder='Feature Name' value={featureKeyValue[index]?.code} className="form-control" style={{ width: "80%" }} key={index} name='code' onChange={(e) => { featureChangeHandler(index, e) }} />
                                    <input type="text" placeholder='Feature Description' value={featureKeyValue[index]?.value} className="form-control" style={{ width: "80%" }} key={index} name='value' onChange={(e) => { featureChangeHandler(index, e) }} />
                                  </div>

                                  {optionValues[optionValues.length - 1] == index && <span style={{ cursor: "pointer" }}
                                    onClick={addHandler}> <AddCircleOutlineIcon />  </span>}


                                </div>

                              </div>
                            })
                          }


                        </div>

                        <div className='d-flex justify-content-end p-2'>
                          <button className='btn btn-primary' onClick={() => onFeatureSaveHandler()} >Save</button>
                        </div>


                      </Box>


                    </Modal>
                  </div>
                </div>
              </div>


            </div>
          </>
        </div>
      </div>


      {/* Modal */}

      <Modal
        open={shipmentModalOpen}
        onClose={handleShipementModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Sstyle} className="col-md-4 ">

          <div className="modal-content " >
            <div className="modal-header p-2 d-flex align-items-center justify-content-between">
              <p className="modal-title genericlabel  " style={{ letterSpacing: "1px" }}>Import Using Excel File..     <span className="text-primary ml-2" style={{ cursor: "pointer" }} onClick={() => { setdownloadCSVModalOpen(true) }} > Download Sample Excel</span> </p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleShipementModalClose} /></span>
              </button>
            </div>
            {/* <div className="modal-body">
              <div className="importingSection">
                <input type="file" id="inputFile" onChange={(e) => {
                  setFile(e.target.files[0]);
                }} /> <br />



              </div>
            </div> */}
            {/* <div className="modal-body">
              <input type="checkbox" onChange={() => setisFandB(!isFandB)} /> <label>Is product type F&B? </label>
            </div> */}
            {/* {!isFandB ? <div className="modal-footer">
              {fullUrl === "multipleselleradmin.thesellerapp.com" ? <button className="btn btn-primary" onClick={handleImport} > Submit </button> : <button className="btn btn-primary" onClick={handleImportForProdXpressbazaar} > Submit </button>}
            </div> : <div className="modal-footer"> <button className="btn btn-primary" onClick={handleFandBImport} > Save </button></div>} */}
          </div>
        </Box>
      </Modal>


      <Modal
        open={downloadCSVModalOpen}
        onClose={handleShipementModalClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={Sstyle} className="col-md-4 ">

          <div className="modal-content " >
            <div className="modal-header p-2 d-flex align-items-center justify-content-between">
              <p className="modal-title genericlabel  " style={{ letterSpacing: "1px" }}> Download Sample Excel File </p>
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span style={{ cursor: "pointer" }} ><CloseIcon onClick={() => { setdownloadCSVModalOpen(false); setSampleCSV({ category: "", product_type: "", sub_category: "", product_type_array: [] }) }} /></span>
              </button>
            </div>
            <div className="modal-body">
              <div>
                <label htmlFor="" className='genericlabel' >Product Category</label>
                <select id="" className='form-control genericlabel' name="category" onChange={(e) => { setSampleCSV((prev) => { return { ...prev, [e.target.name]: e.target.value } }) }} >
                  <option value="" className='genericlabel' selected disabled>Select Category</option>
                  <option value="EB2B" className='genericlabel'>EB2B</option>
                  {categoryList.map(item => {
                    return <option value={item.cat_name} className='genericlabel' key={item.cat_name}>{item.cat_name}</option>
                  })}
                </select>
              </div>

              {productTypeOptions?.length > 0 ? <div className='mt-2'>
                <label htmlFor="" className='genericlabel'>Product Typsse </label>
                <select
                  name="product_type"
                  id=""
                  className="form-control genericlabel"
                  onChange={(e) => {

                    const selectedOption = e.target.options[e.target.selectedIndex];
                    const selectedProductTypeId = selectedOption.getAttribute('data_id') || e.target.value;

                    setSampleCSV((prev) => {
                      return {
                        ...prev,
                        [e.target.name]: e.target.value,
                        sub_category: selectedOption.getAttribute('data_name')
                      };
                    });

                    if (selectedProductTypeId) {
                      getProductAttributes(selectedProductTypeId);
                    }

                  }}
                >
                  <option value="" selected disabled>Select Product Type</option>
                  {productTypeOptions?.map((item, index) => {
                    return (
                      <option value={item.name} key={index} data_name={item.name} data_id={item.id || item._id}>
                        {item.name}
                      </option>
                    );
                  })}
                </select>

              </div> : null}

              {
                sampleCSVdata.category === "Fashion" && <div className='mt-2'>
                  <label htmlFor="" className='genericlabel'>Gender Specification</label>
                  <select name="gender_specification" id="" className="form-control genericlabel"
                    onChange={(e) => {
                      setSampleCSV((prev) => {
                        return {
                          ...prev,
                          [e.target.name]: e.target.value,

                        };
                      });
                    }}
                  >
                    <option value="" selected disabled>Select Gender</option>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                    <option value="boy">Boy</option>
                    <option value="girl">Girl</option>
                  </select>

                </div>
              }

            </div>




            {/* {(sampleCSVdata.category !== "Fashion" && sampleCSVdata.product_type) ? <div className="modal-footer"> */}
            <div className="btn btn-primary font-weight-bold" onClick={generateTemplate} > <button className="btn btn-primary font-weight-bold" > GET CSV</button></div>
            {/* </div> : (sampleCSVdata.category === "Fashion" && sampleCSVdata.product_type && sampleCSVdata.gender_specification) ? <button className="btn btn-primary font-weight-bold" onClick={generateTemplate} > GET CSV</button> : null} */}

          </div>
        </Box>
      </Modal>

      <Modal
        open={StateBasedPriceingopen}
        // onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >

        <Box sx={{ ...sPmstyle }} className="variantBox col-md-4">
          <CloseIcon style={{ position: "absolute", top: "10px", right: "10px", cursor: "pointer" }} onClick={handleStateBasedPricingModalClose} />
          <p className="text-center" style={{ fontSize: "20px", fontWeight: "700" }}>State Wise Pricing..</p>

          <div className="modal-content " >
            <div className="modal-header p-2 d-flex align-items-center justify-content-between">
              <p className="modal-title genericlabel  " style={{ letterSpacing: "1px" }}> State Wise Pricing <input type="checkbox" checked={attributesState?.status} className="" onChange={(e) => setattributeState((prev) => { return { ...prev, status: e.target.checked } })} /> </p>
              <div>

                {!attributesState.adding_new_attr ?
                  <span className='tex-primary' style={anchorStyle}
                    onClick={() => { setattributeState((prev) => { return { ...prev, adding_new_attr: true } }) }} >Add Price</span>
                  : <span style={anchorStyle}
                    onClick={() => { setattributeState((prev) => { return { ...prev, adding_new_attr: false }; }); }} >Price List</span>
                }

                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                  {/* <span style={{ cursor: "pointer" }} ><CloseIcon onClick={handleShipementModalClose} /></span> */}
                </button>
              </div>
            </div>
            {!attributesState?.adding_new_attr ? <div className="modal-body" >
              <div style={{ maxHeight: "250px", overflow: "scroll" }}>
                {(attributesState?.data?.length > 0 && attributesState.attr_is_loading === false) ? <>   {
                  attributesState?.data?.map(item => {
                    function getStateName(stateValue) {
                      let z = IndianStates.filter(item => item.value === stateValue)
                      return z[0].name
                    }
                    return <div key={item?.id}>
                      <p className='genericlabel d-flex justify-content-between align-items-center'>
                        {item.state_name === attributesState?.editing_attr_id ? <> {getStateName(item?.state_name)} | {item.state_name} | Rs <input type="text" value={attributesState?.editing_attr_value} className='form-control w-25' onChange={(e) => { setattributeState((prev) => { return { ...prev, editing_attr_value: e.target.value } }) }} /> </>
                          : <div><span>{getStateName(item?.state_name)} | {item.state_name} | Rs {item?.price}</span> <p style={{ color: "grey" }} > Start: {item?.start_date} | End: {item?.end_date}</p> </div>}

                        {item.state_name === attributesState?.editing_attr_id ? <span className='badge badge-primary' style={{ cursor: "pointer" }} onClick={() => {
                          console.log(attributesState);
                          submitHandler("Update")
                        }} >Update</span> : <span className='d-flex' style={{ gap: "10px" }}>
                          <EditNoteRoundedIcon style={{ color: "green", cursor: "pointer" }} onClick={() => {
                            setattributeState((prev) => { return { ...prev, adding_new_attr: true } });
                            let StateFullName = IndianStates.filter(state => state.value === item.state_name)
                            setSelectedODays([{ ...item, value: item?.state_name, name: StateFullName[0]?.name }]);
                            setattributeState((prev) => { return { ...prev, price: item?.price, start_date: item?.start_date, end_date: item?.end_date, isUpdatingItem: true, stateName: item?.state_name, makeDisable: true, maximum_price: item?.maximum_price } })
                            // console.log(item)
                            // setattributeState((prev) => { return { ...prev, editing_attr_id: item?.state_name, editing_attr_value: item?.price } })
                          }}

                          />
                          {/* <DeleteIcon style={{ color: "red", cursor: "pointer" }} /> */}
                        </span>}
                      </p>
                      <hr />
                    </div>
                  })
                }</> : null}

                {(attributesState?.data?.length < 1 && attributesState.attr_is_loading === false) ?
                  <p className='text-primary text-center'>No Pricing</p>
                  : null}

                {(attributesState?.data?.length < 1 && attributesState.attr_is_loading === true) ?
                  <p className='text-primary text-center'>Loading...</p>
                  : null}
              </div>


            </div> : <div className="modal-body">

              <div >
                <select name="" id="" className='form-control d-none ' value={attributesState?.stateName} onChange={(e) => { setattributeState((prev) => { return { ...prev, stateName: e.target.value } }) }}>
                  <option value="" selected disabled>Select State</option>
                  {IndianStates.map(item => {
                    return <option value={item.value}>{item.name}</option>
                  })}
                </select>

                <Multiselect options={Oweekdays} selectedValues={selectedODays} displayValue="name" onSelect={onSelectHandler} onRemove={onRemoveHandler} disable={attributesState?.makeDisable}></Multiselect>

                <p className="m-0 p-0 mt-2 genericlabel">Selling Price</p>
                <input type="text" placeholder='Enter Selling Price' className='form-control mt-1' value={attributesState?.price} onChange={(e) => { setattributeState((prev) => { return { ...prev, price: e.target.value } }) }} />

                <p className="m-0 p-0 mt-2 genericlabel">MRP</p>
                <input type="text" placeholder='Enter MRP' className='form-control mt-1' value={attributesState?.maximum_price} onChange={(e) => { setattributeState((prev) => { return { ...prev, maximum_price: e.target.value } }) }} />

                <p className="m-0 p-0 mt-2 genericlabel">Start Date</p>
                <input type="date" placeholder='Enter Selling Price' className='form-control mt-1' value={attributesState?.start_date} onChange={(e) => { setattributeState((prev) => { return { ...prev, start_date: e.target.value } }) }} />

                <p className="m-0 p-0 mt-2 genericlabel">End Date</p>
                <input type="date" placeholder='Enter Selling Price' className='form-control mt-1' value={attributesState?.end_date} onChange={(e) => { setattributeState((prev) => { return { ...prev, end_date: e.target.value } }) }} />


                {attributesState?.new_attr_type === "select" && <textarea name="" id="" placeholder='Enter Options' className='form-control mt-3' value={attributesState?.new_attr_options} onChange={(e) => { setattributeState((prev) => { return { ...prev, new_attr_options: e.target.value } }) }}>

                </textarea>}
              </div>


              <div className="modal-header p-2 d-flex align-items-center justify-content-end" style={{ gap: "10px" }}>
                {attributesState?.isUpdatingItem === false ? <div className="d-flex" style={{ gap: "10px" }}>
                  <button className='btn btn-success' onClick={addMoreHandler} > Add More</button>
                  {attributesState?.data?.length > 0 && <button className='btn btn-primary' onClick={() => { submitHandler("Create") }} >  {attributesState?.submitting ? "Please wait" : "Submit"}</button>}
                </div> : <div>
                  <button className='btn btn-success' onClick={() => { updateStatePriceRuleHandler() }} >  {attributesState?.submitting ? "Please wait" : "Update"}</button>

                </div>}
              </div>

            </div>}

          </div>
        </Box>
      </Modal>
      <AntModal
        title="Import Files"
        open={openAntModal}
        onCancel={handleCloseAntModal}
        onOk={handleOkAntModal}
        centered
        height={400}
        style={{ top: "20%", maxWidth: 400 }}
        bodyStyle={{
          maxHeight: "180px",
          overflowY: "auto",
          padding: "20px",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",

        }}
      >
        {/* Modal Content */}


        <form onSubmit={handleSubmit} style={{ width: "100%", textAlign: "center" }}>
          <input
            ref={bulkFileInputRef}
            type="file"
            accept=".csv,.pdf,.xls,.xlsx"
            onChange={handleFileChange}
            style={{
              marginBottom: "10px", // smaller margin for spacing
              width: "80%", // smaller width for input
            }}
          />
          <button type="submit" className="btn btn-success" style={{ width: "80%" }}>
            Upload
          </button>
        </form>
      </AntModal>
      <div>


        <AntModal
          title="Enter Vendor Name"
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          footer={null} // custom footer
        >
          <Input
            placeholder="Enter Vendor Name"
            value={vendorName}
            onChange={(e) => setVendorName(e.target.value)}
            style={{ marginBottom: 16 }}
          />
          <button
            className="btn btn-primary"
            type="primary"
            onClick={handleDownload}
            disabled={!vendorName.trim()}
          >
            Submit
          </button>
        </AntModal>

        {/* Create Brand Modal */}
        <AntModal
          title={<span style={{ fontWeight: 700, fontSize: "16px" }}>Create New Brand</span>}
          open={isCreateBrandModalOpen}
          onCancel={() => {
            setIsCreateBrandModalOpen(false);
            setNewBrandName("");
            setNewBrandImage("");
          }}
          footer={[
            <button
              key="cancel"
              type="button"
              className="btn btn-outline-secondary mr-2"
              onClick={() => {
                setIsCreateBrandModalOpen(false);
                setNewBrandName("");
                setNewBrandImage("");
              }}
              style={{ borderRadius: "6px" }}
            >
              Cancel
            </button>,
            <button
              key="submit"
              type="button"
              className="btn btn-primary"
              disabled={isBrandCreating || brandImageUploading || !newBrandName.trim() || !newBrandImage.trim()}
              onClick={handleCreateBrand}
              style={{ borderRadius: "6px", fontWeight: 600 }}
            >
              {isBrandCreating ? "Creating..." : "Create Brand"}
            </button>
          ]}
        >
          <div className="py-2">
            <div className="form-group mb-3">
              <label className="genericlabel font-weight-bold" style={{ fontSize: "13.5px" }}>
                Brand Name <span className="text-danger">*</span>
              </label>
              <Input
                placeholder="Enter brand name (e.g. Nike, Apple, Amul)"
                size="large"
                value={newBrandName}
                onChange={(e) => setNewBrandName(e.target.value)}
                onPressEnter={handleCreateBrand}
                style={{ borderRadius: "8px" }}
              />
            </div>
            <div className="form-group mb-2">
              <div className="d-flex justify-content-between align-items-center mb-1">
                <label className="genericlabel font-weight-bold mb-0" style={{ fontSize: "13.5px" }}>
                  Brand Logo / Image <span className="text-danger">*</span>
                </label>
                {newBrandImage && (
                  <button
                    type="button"
                    onClick={() => setNewBrandImage("")}
                    className="btn btn-link p-0 text-danger"
                    style={{ fontSize: "12px", textDecoration: "none" }}
                  >
                    <i className="fas fa-trash-alt mr-1"></i> Remove
                  </button>
                )}
              </div>

              <input
                type="file"
                id="brandImageFileInput"
                accept="image/*"
                onChange={handleBrandImageUpload}
                disabled={brandImageUploading}
                className="form-control"
                style={{ height: "42px", borderRadius: "8px" }}
              />

              {brandImageUploading && (
                <div className="mt-2 text-muted" style={{ fontSize: "12px" }}>
                  <i className="fas fa-spinner fa-spin text-primary mr-1"></i> Uploading image...
                </div>
              )}

              {newBrandImage && !brandImageUploading && (
                <div className="mt-2 d-flex align-items-center p-2 border rounded" style={{ gap: "12px", backgroundColor: "#F8FAFC", borderColor: "#E2E8F0" }}>
                  <img
                    src={newBrandImage}
                    alt="Brand Logo Preview"
                    style={{
                      width: "48px",
                      height: "48px",
                      objectFit: "contain",
                      borderRadius: "6px",
                      border: "1px solid #CBD5E1",
                      backgroundColor: "#FFFFFF",
                      padding: "2px"
                    }}
                  />
                  <div style={{ flex: 1, overflow: "hidden" }}>
                    <span className="d-block text-truncate text-muted" style={{ fontSize: "11.5px" }}>
                      {newBrandImage}
                    </span>
                    <span style={{ fontSize: "12px", color: "#16A34A", fontWeight: 600 }}>
                      <i className="fas fa-check-circle mr-1"></i> Uploaded successfully
                    </span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </AntModal>
      </div>
    </ThemeMaker >
  );
};

export default createProduct;
